{
  "about.blocks": "Kiểm duyệt máy chủ khác",
  "about.contact": "Liên lạc:",
  "about.default_locale": "Mặc định",
  "about.disclaimer": "Mastodon là phần mềm tự do nguồn mở của Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Lý do không được cung cấp",
  "about.domain_blocks.preamble": "Mastodon cho phép bạn đọc nội dung và giao tiếp với tài khoản từ bất kỳ máy chủ nào. Còn đây là những ngoại lệ trên máy chủ này.",
  "about.domain_blocks.silenced.explanation": "Nói chung, bạn sẽ không thấy tài khoản và nội dung từ máy chủ này, trừ khi bạn tự tìm kiếm hoặc tự theo dõi.",
  "about.domain_blocks.silenced.title": "Hạn chế",
  "about.domain_blocks.suspended.explanation": "Dữ liệu từ máy chủ này sẽ không được xử lý, lưu trữ hoặc trao đổi. Mọi tương tác hoặc giao tiếp với tài khoản ở máy chủ này đều bị cấm.",
  "about.domain_blocks.suspended.title": "Vô hiệu hóa",
  "about.language_label": "Ngôn ngữ",
  "about.not_available": "Máy chủ này chưa cung cấp thông tin.",
  "about.powered_by": "Mạng xã hội liên hợp {mastodon}",
  "about.rules": "Nội quy máy chủ",
  "account.account_note_header": "Ghi chú",
  "account.activity": "Hoạt động",
  "account.add_note": "Ghi chú",
  "account.add_or_remove_from_list": "Sửa danh sách",
  "account.badges.admin": "Quản trị viên",
  "account.badges.blocked": "Đã chặn",
  "account.badges.bot": "Bot",
  "account.badges.domain_blocked": "Máy chủ đã chặn",
  "account.badges.group": "Nhóm",
  "account.badges.muted": "Đã phớt lờ",
  "account.badges.muted_until": "Bị ẩn tới {until}",
  "account.block": "Chặn @{name}",
  "account.block_domain": "Chặn mọi thứ từ {domain}",
  "account.block_short": "Chặn",
  "account.blocked": "Đã chặn",
  "account.cancel_follow_request": "Thu hồi yêu cầu theo dõi",
  "account.copy": "Sao chép địa chỉ",
  "account.direct": "Nhắn riêng @{name}",
  "account.disable_notifications": "Tắt thông báo khi @{name} đăng tút",
  "account.edit_note": "Sửa ghi chú",
  "account.edit_profile": "Sửa hồ sơ",
  "account.edit_profile_short": "Sửa",
  "account.enable_notifications": "Nhận thông báo khi @{name} đăng tút",
  "account.endorse": "Nêu bật tài khoản này",
  "account.familiar_followers_many": "Theo dõi bởi {name1}, {name2} và {othersCount, plural, other {# tài khoản khác mà bạn biết}}",
  "account.familiar_followers_one": "Theo dõi bởi {name1}",
  "account.familiar_followers_two": "Theo dõi bởi {name1} và {name2}",
  "account.featured": "Nêu bật",
  "account.featured.accounts": "Tài khoản",
  "account.featured.collections": "Gói khởi đầu",
  "account.featured.new_collection": "Gói khởi đầu mới",
  "account.field_overflow": "Hiện đầy đủ nội dung",
  "account.filters.all": "Tất cả hoạt động",
  "account.filters.boosts_toggle": "Hiện những lượt đăng lại",
  "account.filters.posts_boosts": "Tút và lượt đăng lại",
  "account.filters.posts_only": "Tút",
  "account.filters.posts_replies": "Tút và lượt trả lời",
  "account.filters.replies_toggle": "Hiện những lượt trả lời",
  "account.follow": "Theo dõi",
  "account.follow_back": "Theo dõi lại",
  "account.follow_back_short": "Theo dõi lại",
  "account.follow_request": "Yêu cầu theo dõi",
  "account.follow_request_cancel": "Hủy yêu cầu",
  "account.follow_request_cancel_short": "Hủy bỏ",
  "account.follow_request_short": "Yêu cầu",
  "account.followers": "Người theo",
  "account.followers.empty": "Chưa có người theo dõi nào.",
  "account.followers_counter": "{count, plural, other {{counter} người theo dõi}}",
  "account.followers_you_know_counter": "{counter} bạn biết",
  "account.following": "Đang theo",
  "account.following_counter": "{count, plural, other {{counter} theo dõi}}",
  "account.follows.empty": "Tài khoản này chưa theo dõi ai.",
  "account.follows_you": "Đang theo dõi bạn",
  "account.go_to_profile": "Xem hồ sơ",
  "account.hide_reblogs": "Ẩn tút @{name} đăng lại",
  "account.in_memoriam": "Tưởng Niệm.",
  "account.join_modal.day": "Ngày",
  "account.join_modal.me": "Bạn đã tham gia {server} vào",
  "account.join_modal.me_anniversary": "Happy Fediversary! Bạn đã tham gia {server} vào",
  "account.join_modal.me_today": "Đó là ngày đầu tiên của bạn trên {server}!",
  "account.join_modal.other": "{name} đã tham gia {server} vào",
  "account.join_modal.other_today": "Đó là ngày đầu tiên của {name} trên {server}!",
  "account.join_modal.share.celebrate": "Chia sẻ một tút kỷ niệm",
  "account.join_modal.share.intro": "Chia sẻ một tút giới thiệu",
  "account.join_modal.share.welcome": "Chia sẻ một tút chào mừng",
  "account.join_modal.years": "{number, plural, other {năm}}",
  "account.joined_short": "Năm",
  "account.languages": "Đổi ngôn ngữ mong muốn",
  "account.last_active": "Hoạt động lần cuối",
  "account.link_verified_on": "Liên kết này đã được xác minh vào {date}",
  "account.locked_info": "Đây là tài khoản riêng tư. Chủ tài khoản tự mình xét duyệt các yêu cầu theo dõi.",
  "account.media": "Phương tiện",
  "account.mention": "Nhắc đến @{name}",
  "account.menu.add_to_list": "Thêm vào danh sách",
  "account.menu.block": "Chặn tài khoản",
  "account.menu.block_domain": "Chặn {domain}",
  "account.menu.copied": "Đã sao chép liên kết tài khoản vào clipboard",
  "account.menu.copy": "Sao chép liên kết",
  "account.menu.direct": "Nhắn riêng",
  "account.menu.hide_reblogs": "Ẩn đăng lại trên bảng tin",
  "account.menu.mention": "Nhắc đến",
  "account.menu.mute": "Phớt lờ tài khoản",
  "account.menu.note.description": "Chỉ hiển thị với bạn",
  "account.menu.open_original_page": "Xem trên {domain}",
  "account.menu.remove_follower": "Xóa người theo dõi",
  "account.menu.report": "Báo cáo tài khoản",
  "account.menu.share": "Chia sẻ…",
  "account.menu.show_reblogs": "Hện đăng lại trên bảng tin",
  "account.menu.unblock": "Bỏ chặn tài khoản",
  "account.menu.unblock_domain": "Bỏ chặn {domain}",
  "account.menu.unmute": "Bỏ phớt lờ tài khoản",
  "account.moved_to": "{name} đã chuyển sang máy chủ khác",
  "account.mute": "Phớt lờ @{name}",
  "account.mute_notifications_short": "Phớt lờ thông báo",
  "account.mute_short": "Phớt lờ",
  "account.muted": "Đã phớt lờ",
  "account.mutual": "Theo dõi nhau",
  "account.name.copy": "Sao chép địa chỉ",
  "account.name.help.domain": "{domain} là máy chủ lưu trữ hồ sơ và tút của tài khoản.",
  "account.name.help.domain_self": "{domain} là máy chủ lưu trữ hồ sơ và tút của bạn.",
  "account.name.help.footer": "Giống như việc bạn có thể gửi email cho những người sử dụng các nhà cung cấp email khác nhau, bạn cũng có thể tương tác với những người trên các máy chủ Mastodon khác và với bất kỳ ai trên các ứng dụng Fediverse khác.",
  "account.name.help.header": "Một địa chỉ giống như địa chỉ email",
  "account.name.help.username": "{username} là tên người dùng duy nhất trên máy chủ này. Các máy chủ khác có thể cũng có tên người dùng giống vậy.",
  "account.name.help.username_self": "{username} là tên người dùng của bạn trên máy chủ này. Các máy chủ khác cũng có thể có tên người dùng giống bạn.",
  "account.name_info": "Điều này nghĩa là gì?",
  "account.no_bio": "Chưa có miêu tả.",
  "account.node_modal.callout": "Các ghi chú chỉ hiển thị với bạn.",
  "account.node_modal.edit_title": "Sửa ghi chú",
  "account.node_modal.error_unknown": "Không thể lưu ghi chú",
  "account.node_modal.field_label": "Ghi chú",
  "account.node_modal.save": "Lưu",
  "account.node_modal.title": "Thêm ghi chú",
  "account.note.edit_button": "Sửa",
  "account.note.title": "Ghi chú (chỉ hiển thị với bạn)",
  "account.open_original_page": "Mở liên kết gốc",
  "account.pending": "Đợi duyệt",
  "account.posts": "Tút",
  "account.remove_from_followers": "Xóa người theo dõi {name}",
  "account.report": "Báo cáo @{name}",
  "account.requested_follow": "{name} yêu cầu theo dõi bạn",
  "account.share": "Chia sẻ @{name}",
  "account.show_reblogs": "Hiện tút do @{name} đăng lại",
  "account.statuses_counter": "{count, plural, other {{counter} Tút}}",
  "account.timeline.pinned": "Đã ghim",
  "account.timeline.pinned.view_all": "Xem toàn bộ tút đã ghim",
  "account.unblock": "Bỏ chặn @{name}",
  "account.unblock_domain": "Bỏ ẩn {domain}",
  "account.unblock_domain_short": "Bỏ chặn",
  "account.unblock_short": "Bỏ chặn",
  "account.unendorse": "Bỏ nêu bật tài khoản này",
  "account.unfollow": "Bỏ theo dõi",
  "account.unmute": "Bỏ phớt lờ @{name}",
  "account.unmute_notifications_short": "Bỏ phớt lờ thông báo",
  "account.unmute_short": "Bỏ phớt lờ",
  "account_edit.advanced_settings.bot_hint": "Tài khoản này tự động thực hiện các hành động và không cần thiết theo dõi",
  "account_edit.advanced_settings.bot_label": "Tài khoản tự động",
  "account_edit.advanced_settings.title": "Thiết lập nâng cao",
  "account_edit.bio.add_label": "Thêm giới thiệu",
  "account_edit.bio.edit_label": "Sửa giới thiệu",
  "account_edit.bio.placeholder": "Giúp mọi người nhận ra bạn là ai.",
  "account_edit.bio.title": "Giới thiệu",
  "account_edit.bio_modal.add_title": "Thêm giới thiệu",
  "account_edit.bio_modal.edit_title": "Sửa giới thiệu",
  "account_edit.column_button": "Xong",
  "account_edit.column_title": "Sửa hồ sơ",
  "account_edit.custom_fields.add_label": "Thêm trường",
  "account_edit.custom_fields.edit_label": "Sửa trường",
  "account_edit.custom_fields.placeholder": "Thêm nghề nghiệp, liên kết ngoài hoặc bất kỳ gì mà bạn muốn.",
  "account_edit.custom_fields.reorder_button": "Sắp xếp trường",
  "account_edit.custom_fields.tip_content": "Bạn có thể dễ dàng tăng độ tin cậy cho tài khoản Mastodon của mình bằng cách xác minh liên kết đến bất kỳ trang web nào bạn sở hữu.",
  "account_edit.custom_fields.tip_title": "Mẹo: Thêm liên kết xác minh",
  "account_edit.custom_fields.title": "Trường tùy chỉnh",
  "account_edit.custom_fields.verified_hint": "Làm thế nào để thêm liên kết xác minh?",
  "account_edit.display_name.add_label": "Thêm tên gọi",
  "account_edit.display_name.edit_label": "Sửa tên gọi",
  "account_edit.display_name.placeholder": "Tên gọi là tên hiển thị trên hồ sơ của bạn và bảng tin.",
  "account_edit.display_name.title": "Tên gọi",
  "account_edit.featured_hashtags.edit_label": "Thêm hashtag",
  "account_edit.featured_hashtags.placeholder": "Giúp mọi người xác định và truy cập nhanh những chủ đề mà bạn thích.",
  "account_edit.featured_hashtags.title": "Hashtag thường dùng",
  "account_edit.field_actions.delete": "Xóa trường",
  "account_edit.field_actions.edit": "Sửa trường",
  "account_edit.field_delete_modal.confirm": "Bạn có chắc muốn xóa trường này? Hành động này không thể hoàn tác.",
  "account_edit.field_delete_modal.delete_button": "Xóa",
  "account_edit.field_delete_modal.title": "Xóa trường tùy chỉnh?",
  "account_edit.field_edit_modal.add_title": "Thêm trường tùy chỉnh",
  "account_edit.field_edit_modal.discard_confirm": "Loại bỏ",
  "account_edit.field_edit_modal.discard_message": "Bạn có các thay đổi chưa được lưu. Bạn có muốn loại bỏ chúng?",
  "account_edit.field_edit_modal.edit_title": "Sửa trường tùy chỉnh",
  "account_edit.field_edit_modal.length_warning": "Vượt quá giới hạn ký tự. Người dùng điện thoại sẽ không thể thấy đầy đủ.",
  "account_edit.field_edit_modal.link_emoji_warning": "Không nên dùng emoji tùy chỉnh với url. Trường tùy chỉnh chứa cả hai sẽ chỉ hiển thị văn bản, để ngăn chặn việc bối rối.",
  "account_edit.field_edit_modal.name_hint": "Vd: “Website cá nhân”",
  "account_edit.field_edit_modal.name_label": "Nhãn",
  "account_edit.field_edit_modal.url_warning": "Để thêm một liên kết, vui lòng đặt {protocol} ở đầu.",
  "account_edit.field_edit_modal.value_hint": "Vd: “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Giá trị",
  "account_edit.field_reorder_modal.drag_cancel": "Đã hủy kéo. Trường \"{item}\" đã được thả.",
  "account_edit.field_reorder_modal.drag_end": "Trường \"{item}\" đã được thả.",
  "account_edit.field_reorder_modal.drag_instructions": "Để sắp xếp lại các trường tùy chỉnh, nhấn phím cách hoặc phím Enter. Trong khi kéo, sử dụng các phím mũi tên để di chuyển trường lên hoặc xuống. Nhấn phím cách hoặc phím Enter một lần nữa để thả trường vào vị trí mới, hoặc nhấn phím Escape để hủy bỏ.",
  "account_edit.field_reorder_modal.drag_move": "Trường \"{item}\" đã được di chuyển.",
  "account_edit.field_reorder_modal.drag_over": "Trường \"{item}\" đã được di chuyển lên trên \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Đã chọn trường \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Kéo trường \"{item}\"",
  "account_edit.field_reorder_modal.title": "Sắp xếp lại trường",
  "account_edit.image_alt_modal.add_title": "Thêm văn bản thay thế",
  "account_edit.image_alt_modal.details_content": "NÊN: <ul> <li>Mô tả bản thân bạn trong hình</li> <li>Dùng ngôn ngữ góc nhìn thứ ba (ví dụ “Alex” thay vì “tôi”)</li> <li>Súc tích – một vài từ là đủ</li> </ul> KHÔNG NÊN: <ul> <li>Bắt đầu bằng “Hình ảnh của” – điều này là thừa đối với trình đọc màn hình.</li> </ul> VÍ DỤ: <ul> <li>“Alex mặc áo xanh và đeo kính”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Gợi ý: Văn bản thay thế của ảnh đại diện",
  "account_edit.image_alt_modal.edit_title": "Sửa văn bản thay thế",
  "account_edit.image_alt_modal.text_hint": "Văn bản thay thế giúp người dùng phần mềm đọc màn hình hiểu được nội dung của bạn.",
  "account_edit.image_alt_modal.text_label": "Văn bản thay thế",
  "account_edit.image_delete_modal.confirm": "Bạn có chắc chắn muốn xóa hình ảnh này? Hành động này không thể hoàn tác.",
  "account_edit.image_delete_modal.delete_button": "Xóa",
  "account_edit.image_delete_modal.title": "Xóa hình ảnh?",
  "account_edit.image_edit.add_button": "Thêm ảnh",
  "account_edit.image_edit.alt_add_button": "Thêm văn bản thay thế",
  "account_edit.image_edit.alt_edit_button": "Sửa văn bản thay thế",
  "account_edit.image_edit.remove_button": "Gỡ ảnh",
  "account_edit.image_edit.replace_button": "Thay thế ảnh",
  "account_edit.item_list.delete": "Xóa {name}",
  "account_edit.item_list.edit": "Sửa {name}",
  "account_edit.name_modal.add_title": "Thêm tên gọi",
  "account_edit.name_modal.edit_title": "Sửa tên gọi",
  "account_edit.profile_tab.button_label": "Tùy chỉnh",
  "account_edit.profile_tab.hint.description": "Những thiết lập này tùy chỉnh những gì người dùng thấy trên {server} trong ứng dụng chính thức, nhưng có thể sẽ không thấy trên các máy chủ khác hoặc các ứng dụng thứ ba.",
  "account_edit.profile_tab.hint.title": "Hiển thị vẫn đa dạng",
  "account_edit.profile_tab.show_featured.description": "‘Nêu bật’ là một tab tùy chọn, giúp bạn nêu bật các tài khoản khác.",
  "account_edit.profile_tab.show_featured.title": "Hiện tab ‘Nêu bật’",
  "account_edit.profile_tab.show_media.description": "‘Phương tiện’ là một tab tùy chọn, hiển thị những tút có chứa hình ảnh hoặc video của bạn.",
  "account_edit.profile_tab.show_media.title": "Hiện tab ‘Phương tiện’",
  "account_edit.profile_tab.show_media_replies.description": "Nếu bật, tab Phương tiện sẽ hiện cả những tút của bạn lẫn những trả lời tới tút của người khác.",
  "account_edit.profile_tab.show_media_replies.title": "Bao gồm tút dạng trả lời trong tab ‘Phương tiện’",
  "account_edit.profile_tab.show_relations.description": "Hiển thị các tài khoản bạn theo dõi và những người bạn đang theo dõi trên hồ sơ của bạn. Mọi người vẫn có thể thấy liệu bạn có đang theo dõi họ hay không.",
  "account_edit.profile_tab.show_relations.title": "Hiện ‘Người theo dõi’ và ‘Đang theo dõi’",
  "account_edit.profile_tab.subtitle": "Tùy chỉnh cách hiển thị hồ sơ của bạn.",
  "account_edit.profile_tab.title": "Thiết lập hồ sơ",
  "account_edit.save": "Lưu",
  "account_edit.upload_modal.back": "Quay lại",
  "account_edit.upload_modal.done": "Xong",
  "account_edit.upload_modal.next": "Kế tiếp",
  "account_edit.upload_modal.step_crop.zoom": "Phóng to",
  "account_edit.upload_modal.step_upload.button": "Duyệt tệp",
  "account_edit.upload_modal.step_upload.dragging": "Thả để tải lên",
  "account_edit.upload_modal.step_upload.header": "Chọn ảnh",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF hoặc JPG, tối đa {limit}MB.{br}Sẽ bị thu xuống {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Thêm ảnh đại diện",
  "account_edit.upload_modal.title_add.header": "Thêm ảnh bìa",
  "account_edit.upload_modal.title_replace.avatar": "Thay thế ảnh đại diện",
  "account_edit.upload_modal.title_replace.header": "Thay thế ảnh bìa",
  "account_edit.verified_modal.details": "Tăng độ tin cậy cho hồ sơ Mastodon của bạn bằng cách xác minh liên kết đến trang web cá nhân. Cách thức thực hiện như sau:",
  "account_edit.verified_modal.invisible_link.details": "Thêm liên kết trên header của trang. Quan trọng là rel=\"me\" giúp ngăn chặn việc mạo danh trên các trang web có nội dung do người dùng tạo. Bạn cũng có thể sử dụng một thẻ link thay vì {tag}, nhưng HTML phải có thể truy cập được mà không cần thực thi JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Làm thế nào để ẩn liên kết?",
  "account_edit.verified_modal.step1.header": "Sao chép đoạn mã HTML bên dưới và dán vào phần đầu (header) của trang web của bạn",
  "account_edit.verified_modal.step2.details": "Nếu bạn từng trang web của mình dưới dạng trường tùy chỉnh, bạn cần xóa và thêm lại trang web đó để kích hoạt quá trình xác minh.",
  "account_edit.verified_modal.step2.header": "Thêm trang web của bạn dưới dạng trường tùy chỉnh",
  "account_edit.verified_modal.title": "Làm thế nào để thêm liên kết xác minh",
  "account_edit_tags.add_tag": "Thêm #{tagName}",
  "account_edit_tags.column_title": "Sửa nhãn",
  "account_edit_tags.help_text": "Hashtag thường dùng giúp bạn mọi người khám phá và tương tác với hồ sơ của bạn. Chúng xuất hiện như những bộ lọc trên phần Hoạt động hồ sơ.",
  "account_edit_tags.max_tags_reached": "Bạn đã đạt số lượng hashtag thường dùng tối đa.",
  "account_edit_tags.search_placeholder": "Nhập một hashtag…",
  "account_edit_tags.suggestions": "Được đề xuất:",
  "account_edit_tags.tag_status_count": "{count, plural, other {# tút}}",
  "account_list.hidden_notice": "Chỉ bạn mới thấy. Để hiển thị danh sách này cho người khác, hãy vào <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, other {# tài khoản}}",
  "account_note.placeholder": "Nhấn để thêm",
  "admin.dashboard.daily_retention": "Tỉ lệ người dùng sau đăng ký ở lại theo ngày",
  "admin.dashboard.monthly_retention": "Tỉ lệ người dùng ở lại sau khi đăng ký",
  "admin.dashboard.retention.average": "Trung bình",
  "admin.dashboard.retention.cohort": "Tháng đăng ký",
  "admin.dashboard.retention.cohort_size": "Mới",
  "admin.impact_report.instance_accounts": "Hồ sơ tài khoản này sẽ xóa",
  "admin.impact_report.instance_followers": "Người theo dõi của thành viên máy chủ sẽ bị mất",
  "admin.impact_report.instance_follows": "Người mà thành viên máy chủ theo dõi sẽ bị mất",
  "admin.impact_report.title": "Mô tả ảnh hưởng",
  "alert.rate_limited.message": "Vui lòng thử lại sau {retry_time, time, medium}.",
  "alert.rate_limited.title": "Vượt giới hạn",
  "alert.unexpected.message": "Đã xảy ra lỗi không mong muốn.",
  "alert.unexpected.title": "Ốii!",
  "alt_text_badge.title": "Văn bản thay thế",
  "alt_text_modal.add_alt_text": "Thêm văn bản thay thế",
  "alt_text_modal.add_text_from_image": "Thêm văn bản từ ảnh",
  "alt_text_modal.cancel": "Hủy bỏ",
  "alt_text_modal.change_thumbnail": "Đổi thumbnail",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Mô tả cho người khiếm thính…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Mô tả cho người khiếm thị…",
  "alt_text_modal.done": "Xong",
  "announcement.announcement": "Có gì mới?",
  "annual_report.announcement.action_build": "Tạo Wrapstodon của tôi",
  "annual_report.announcement.action_dismiss": "Không, cảm ơn",
  "annual_report.announcement.action_view": "Xem Wrapstodon của tôi",
  "annual_report.announcement.description": "Tìm hiểu thêm về mức độ tương tác của bạn trên Mastodon trong năm qua.",
  "annual_report.announcement.title": "Wrapstodon {year} đã đến",
  "annual_report.nav_item.badge": "Mới",
  "annual_report.shared_page.donate": "Quyên góp",
  "annual_report.shared_page.footer": "Tạo bằng {heart} bởi đội ngũ Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} ở {domain}, một trong nhiều cộng đồng Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} thích tìm kiếm và đăng lại các tút, lan tỏa những tài khoản khác với mục tiêu hoàn hảo.",
  "annual_report.summary.archetype.booster.desc_self": "Bạn thích tìm kiếm và đăng lại các tút, lan tỏa những tài khoản khác với mục tiêu hoàn hảo.",
  "annual_report.summary.archetype.booster.name": "Cung Thủ",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Chúng tôi biết {name} đang ở đâu đó ngoài kia, tận hưởng Mastodon theo cách riêng của họ.",
  "annual_report.summary.archetype.lurker.desc_self": "Chúng tôi biết bạn đang ở đâu đó ngoài kia, tận hưởng Mastodon theo cách riêng.",
  "annual_report.summary.archetype.lurker.name": "Lãng Nhân",
  "annual_report.summary.archetype.oracle.desc_public": "{name} tạo ra nhiều tút mới hơn là trả lời, giúp Mastodon luôn mới mẻ và hướng tới tương lai.",
  "annual_report.summary.archetype.oracle.desc_self": "Bạn tạo ra nhiều tút mới hơn là trả lời, giúp Mastodon luôn mới mẻ và hướng tới tương lai.",
  "annual_report.summary.archetype.oracle.name": "Tiên Tri",
  "annual_report.summary.archetype.pollster.desc_public": "{name} tạo ra nhiều cuộc vốt hơn các loại tút khác, khơi dậy sự tò mò trên Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Bạn tạo ra nhiều cuộc vốt hơn các loại tút khác, khơi dậy sự tò mò trên Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Mọt Sách",
  "annual_report.summary.archetype.replier.desc_public": "{name} thường xuyên trả lời tút của người khác, mang đến cho Mastodon những cuộc thảo luận mới.",
  "annual_report.summary.archetype.replier.desc_self": "Bạn thường xuyên trả lời tút của người khác, mang đến cho Mastodon những cuộc thảo luận mới.",
  "annual_report.summary.archetype.replier.name": "Bướm Xinh",
  "annual_report.summary.archetype.reveal": "Bật mí nguyên mẫu của tôi",
  "annual_report.summary.archetype.reveal_description": "Cảm ơn bạn đã là một phần của Mastodon! Đã đến lúc tìm hiểu xem bạn thuộc nguyên mẫu nào vào năm {year}.",
  "annual_report.summary.archetype.title_public": "Nguyên mẫu của {name}",
  "annual_report.summary.archetype.title_self": "Nguyên mẫu của bạn",
  "annual_report.summary.close": "Đóng",
  "annual_report.summary.copy_link": "Sao chép liên kết",
  "annual_report.summary.followers.new_followers": "{count, plural, other {người theo dõi mới}}",
  "annual_report.summary.highlighted_post.boost_count": "Tút này được đăng lại {count, plural, other {# lần}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Tút này được thích {count, plural, other {# lần}}.",
  "annual_report.summary.highlighted_post.reply_count": "Tút này có {count, plural, other {# lượt trả lời}}.",
  "annual_report.summary.highlighted_post.title": "Tút nổi tiếng nhất",
  "annual_report.summary.most_used_app.most_used_app": "app dùng nhiều nhất",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "hashtag dùng nhiều nhất",
  "annual_report.summary.most_used_hashtag.used_count": "Bạn đã dùng hashtag này trong {count, plural, other {# tút}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} đã dùng hashtag này trong {count, plural, other {# tút}}.",
  "annual_report.summary.new_posts.new_posts": "tút mới",
  "annual_report.summary.percentile.text": "<topLabel>Bạn thuộc top</topLabel><percentage></percentage><bottomLabel>thành viên của {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Chúng tôi sẽ không kể cho Bernie.",
  "annual_report.summary.share_elsewhere": "Chia sẻ nơi khác",
  "annual_report.summary.share_message": "Tôi là điển hình {archetype}!",
  "annual_report.summary.share_on_mastodon": "Chia sẻ lên Mastodon",
  "attachments_list.unprocessed": "(chưa xử lí)",
  "audio.hide": "Ẩn âm thanh",
  "block_modal.no_collections": "Cả hai bạn đều không thể thêm nhau vào gói khởi đầu. Nếu có, bạn sẽ tự động bị xóa khỏi gói khởi đầu hiện có của người kia.",
  "block_modal.remote_users_caveat": "Chúng tôi sẽ yêu cầu {domain} tôn trọng quyết định của bạn. Tuy nhiên, việc tuân thủ không được đảm bảo vì một số máy chủ có thể xử lý việc chặn theo cách khác nhau. Các tút công khai vẫn có thể hiển thị đối với người dùng chưa đăng nhập.",
  "block_modal.show_less": "Thu gọn",
  "block_modal.show_more": "Hiện thêm",
  "block_modal.they_cant_mention": "Bạn không thể nhắc đến, theo dõi hoặc trích dẫn lẫn nhau.",
  "block_modal.they_cant_see_posts": "Bạn và họ sẽ không nhìn thấy tút của nhau.",
  "block_modal.they_will_know": "Họ sẽ biết đã bị bạn chặn.",
  "block_modal.title": "Chặn tài khoản này?",
  "block_modal.you_wont_see_mentions": "Bạn không còn thấy tút có nhắc đến họ.",
  "boost_modal.combo": "Nhấn {combo} để bỏ qua bước này",
  "boost_modal.reblog": "Đăng lại?",
  "boost_modal.undo_reblog": "Bỏ đăng lại?",
  "bundle_column_error.copy_stacktrace": "Sao chép báo lỗi",
  "bundle_column_error.error.body": "Không thể hiện trang này. Đây có thể là một lỗi trong mã lập trình của chúng tôi, hoặc là vấn đề tương thích của trình duyệt.",
  "bundle_column_error.error.title": "Ôi không!",
  "bundle_column_error.network.body": "Đã xảy ra lỗi khi tải trang này. Đây có thể là vấn đề tạm thời rớt mạng của bạn hoặc máy chủ này.",
  "bundle_column_error.network.title": "Lỗi mạng",
  "bundle_column_error.retry": "Thử lại",
  "bundle_column_error.return": "Quay lại trang chủ",
  "bundle_column_error.routing.body": "Không thể tìm thấy trang cần tìm. Bạn có chắc URL trong thanh địa chỉ là chính xác?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Đóng",
  "bundle_modal_error.message": "Đã có lỗi xảy ra trong khi tải màn hình này.",
  "bundle_modal_error.retry": "Thử lại",
  "callout.dismiss": "Bỏ qua",
  "carousel.current": "<sr>Slide</sr> {current, number} / {max, number}",
  "carousel.slide": "Slide {current, number} trong {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} ký tự đề xuất",
  "character_counter.required": "{currentLength}/{maxLength} ký tự",
  "closed_registrations.other_server_instructions": "Tạo tài khoản trên máy chủ khác và vẫn tương tác với máy chủ này.",
  "closed_registrations_modal.description": "{domain} hiện tắt đăng ký, nhưng hãy lưu ý rằng bạn không cần một tài khoản riêng trên {domain} để sử dụng Mastodon.",
  "closed_registrations_modal.find_another_server": "Tìm máy chủ khác",
  "closed_registrations_modal.preamble": "Mastodon liên hợp nên bất kể bạn tạo tài khoản ở đâu, bạn cũng sẽ có thể theo dõi và tương tác với tài khoản trên máy chủ này. Bạn thậm chí có thể tự mở máy chủ!",
  "closed_registrations_modal.title": "Đăng ký Mastodon",
  "collection.share_modal.share_link_label": "Chia sẻ liên kết",
  "collection.share_modal.share_via_post": "Đăng lên Mastodon",
  "collection.share_modal.share_via_system": "Chia sẻ qua…",
  "collection.share_modal.title": "Chia sẻ gói khởi đầu",
  "collection.share_modal.title_new": "Chia sẻ gói khởi đầu mới của bạn!",
  "collection.share_template_other": "Xem ngay gói khởi đầu tuyệt vời này: {link}",
  "collection.share_template_own": "Xem ngay gói khởi đầu mới của tôi: {link}",
  "collections.account_count": "{count, plural, other {# tài khoản}}",
  "collections.accounts.empty_description": "Thêm tối đa {count} tài khoản",
  "collections.accounts.empty_editor_title": "Chưa có ai trong gói khởi đầu này",
  "collections.accounts.empty_title": "Gói khởi đầu này trống",
  "collections.block_collection_owner": "Chặn tài khoản",
  "collections.by_account": "bởi {account_handle}",
  "collections.collection_description": "Mô tả",
  "collections.collection_language": "Ngôn ngữ",
  "collections.collection_language_none": "Không",
  "collections.collection_name": "Tên",
  "collections.collection_topic": "Chủ đề",
  "collections.confirm_account_removal": "Bạn có chắc muốn gỡ tài khoản này khỏi gói khởi đầu?",
  "collections.content_warning": "Nội dung ẩn",
  "collections.continue": "Tiếp tục",
  "collections.copy_link": "Sao chép liên kết",
  "collections.copy_link_confirmation": "Sao chép liên kết tài khoản vào clipboard",
  "collections.create.accounts_title": "Bạn sẽ chọn ai để giới thiệu trong gói khởi đầu này?",
  "collections.create.basic_details_title": "Thông tin cơ bản",
  "collections.create.steps": "Bước {step}/{total}",
  "collections.create_collection": "Tạo gói khởi đầu",
  "collections.delete_collection": "Xóa gói khởi đầu",
  "collections.description_length_hint": "Giới hạn 100 ký tự",
  "collections.detail.author_added_you_on_date": "{author} đã thêm bạn vào {date}",
  "collections.detail.loading": "Đang tải gói khởi đầu…",
  "collections.detail.revoke_inclusion": "Xóa tôi",
  "collections.detail.sensitive_content": "Nội dung nhạy cảm",
  "collections.detail.sensitive_note": "Gói khởi đầu này chứa các tài khoản và nội dung có thể nhạy cảm đối với một số người.",
  "collections.detail.share": "Chia sẻ gói khởi đầu này",
  "collections.detail.you_are_in_this_collection": "Bạn đã được thêm vào gói khởi đầu này",
  "collections.edit_details": "Sửa chi tiết",
  "collections.error_loading_collections": "Đã xảy ra lỗi khi tải những gói khởi đầu này.",
  "collections.hidden_accounts_description": "Bạn vừa chặn hoặc phớt lờ {count, plural, other {tài khoản này}}",
  "collections.hidden_accounts_link": "{count, plural, other {# tài khoản đã ẩn}}",
  "collections.hints.accounts_counter": "{count}/{max} tài khoản",
  "collections.last_updated_at": "Lần cuối cập nhật: {date}",
  "collections.list.collections_with_count": "{count, plural, other {# Gói khởi đầu}}",
  "collections.list.created_by_author": "Tạo bởi {name}",
  "collections.list.created_by_you": "Được tạo bởi bạn",
  "collections.list.featuring_you": "Có mặt bạn",
  "collections.manage_accounts": "Quản lý tài khoản",
  "collections.mark_as_sensitive": "Đánh dấu nhạy cảm",
  "collections.mark_as_sensitive_hint": "Ẩn phần mô tả và các tài khoản của gói khởi đầu phía sau cảnh báo nội dung. Tên gói khởi đầu vẫn hiển thị.",
  "collections.maximum_collection_count_description": "Máy chủ của bạn cho phép tạo tối đa {count} gói khởi đầu.",
  "collections.maximum_collection_count_reached": "Bạn đã đạt đến số lượng gói khởi đầu tối đa",
  "collections.name_length_hint": "Giới hạn 40 ký tự",
  "collections.new_collection": "Gói khởi đầu mới",
  "collections.pending_accounts.message": "Tài khoản có thể hiển thị trạng thái chờ duyệt khi chúng tôi đang chờ phản hồi từ người dùng hoặc máy chủ của họ. Chỉ bạn mới có thể xem được các tài khoản đang chờ duyệt.",
  "collections.pending_accounts.title": "Vì sao tôi thấy những tài khoản đang chờ duyệt?",
  "collections.remove_account": "Gỡ",
  "collections.report_collection": "Báo cáo gói khởi đầu này",
  "collections.revoke_collection_inclusion": "Xóa tôi khỏi gói khởi đầu này",
  "collections.revoke_inclusion.confirmation": "Bạn đã được gỡ khỏi \"{collection}\"",
  "collections.revoke_inclusion.error": "Đã có lỗi, xin vui lòng thử lại.",
  "collections.search_accounts_label": "Tìm tài khoản để thêm",
  "collections.search_accounts_max_reached": "Bạn đã đạt đến số lượng tài khoản tối đa",
  "collections.sensitive": "Nhạy cảm",
  "collections.share_short": "Chia sẻ",
  "collections.suggestions.can_not_add": "Không thể thêm",
  "collections.suggestions.can_not_add_desc": "Những tài khoản này không muốn khám phá, hoặc họ ở trên máy chủ chưa hỗ trợ gói khởi đầu.",
  "collections.suggestions.must_follow": "Cần theo dõi trước",
  "collections.suggestions.must_follow_desc": "Những tài khoản này phê duyệt yêu cầu theo dõi. Người theo dõi mới có thể thêm họ vào gói khởi đầu.",
  "collections.topic_hint": "Thêm hashtag giúp mọi người hiểu chủ đề chính của gói khởi đầu này.",
  "collections.topic_special_chars_hint": "Những ký tự đặc biệt sẽ bị xóa khi lưu",
  "collections.unlisted_collections_description": "Những thông tin này sẽ không hiển thị trên hồ sơ của bạn. Bất cứ ai có liên kết đều có thể tìm thấy chúng.",
  "collections.unlisted_collections_with_count": "Gói khởi đầu hạn chế ({count})",
  "collections.view_collection": "Xem gói khởi đầu",
  "collections.visibility_public": "Công khai",
  "collections.visibility_public_hint": "Có thể tìm thấy trong kết quả tìm kiếm và các khu vực đề xuất khác.",
  "collections.visibility_title": "Hiển thị",
  "collections.visibility_unlisted": "Hạn chế",
  "collections.visibility_unlisted_hint": "Hiển thị cho bất kỳ ai có liên kết. Ẩn khỏi kết quả tìm kiếm và đề xuất.",
  "column.about": "Giới thiệu",
  "column.blocks": "Tài khoản đã chặn",
  "column.bookmarks": "Những tút đã lưu",
  "column.community": "Máy chủ này",
  "column.create_list": "Tạo danh sách",
  "column.direct": "Nhắn riêng",
  "column.directory": "Tìm tài khoản",
  "column.domain_blocks": "Máy chủ đã chặn",
  "column.edit_list": "Sửa danh sách",
  "column.favourites": "Những tút đã thích",
  "column.firehose": "Bảng tin",
  "column.firehose_local": "Bảng tin máy chủ này",
  "column.firehose_singular": "Bảng tin",
  "column.follow_requests": "Yêu cầu theo dõi",
  "column.home": "Trang chủ",
  "column.list_members": "Quản lý tài khoản trong danh sách",
  "column.lists": "Danh sách",
  "column.mutes": "Tài khoản đã phớt lờ",
  "column.notifications": "Thông báo",
  "column.other_collections": "Gói khởi đầu bởi {name}",
  "column.pins": "Tút ghim",
  "column.public": "Liên hợp",
  "column.your_collections": "Gói khởi đầu của bạn",
  "column_back_button.label": "Quay lại",
  "column_header.hide_settings": "Ẩn bộ lọc",
  "column_header.moveLeft_settings": "Dời cột sang bên trái",
  "column_header.moveRight_settings": "Dời cột sang bên phải",
  "column_header.pin": "Ghim",
  "column_header.show_settings": "Hiện bộ lọc",
  "column_header.unpin": "Không ghim",
  "column_search.cancel": "Hủy bỏ",
  "combobox.close_results": "Đóng kết quả",
  "combobox.loading": "Đang tải",
  "combobox.no_results_found": "Không có kết quả cho tìm kiếm này",
  "combobox.open_results": "Mở kết quả",
  "combobox.results_available": "{count, plural, other {# đề xuất}} có sẵn. Sử dụng các phím mũi tên lên và xuống để điều hướng. Nhấn phím Enter để chọn.",
  "community.column_settings.local_only": "Chỉ máy chủ của bạn",
  "community.column_settings.media_only": "Chỉ hiện tút có media",
  "community.column_settings.remote_only": "Chỉ tài khoản ở máy chủ khác",
  "compose.error.blank_post": "Không thể để trống.",
  "compose.language.change": "Chọn ngôn ngữ tút",
  "compose.language.search": "Tìm ngôn ngữ...",
  "compose.published.body": "Tút đã được đăng.",
  "compose.published.open": "Xem lại",
  "compose.saved.body": "Đã lưu tút.",
  "compose_form.direct_message_warning_learn_more": "Tìm hiểu thêm",
  "compose_form.encryption_warning": "Các tút trên Mastodon không được mã hóa đầu cuối. Không chia sẻ bất kỳ thông tin nhạy cảm nào qua Mastodon.",
  "compose_form.hashtag_warning": "Tút này sẽ không xuất hiện công khai. Chỉ những tút công khai mới có thể được tìm kiếm thông qua hashtag.",
  "compose_form.lock_disclaimer": "Tài khoản của bạn không {locked}. Bất kỳ ai cũng có thể theo dõi và xem tút chỉ dành cho người theo dõi bạn.",
  "compose_form.lock_disclaimer.lock": "khóa",
  "compose_form.placeholder": "Bạn đang nghĩ gì?",
  "compose_form.poll.duration": "Hết hạn sau",
  "compose_form.poll.multiple": "Chọn nhiều",
  "compose_form.poll.option_placeholder": "Lựa chọn {number}",
  "compose_form.poll.single": "Chọn một",
  "compose_form.poll.switch_to_multiple": "Có thể chọn nhiều lựa chọn",
  "compose_form.poll.switch_to_single": "Chỉ cho phép chọn duy nhất một lựa chọn",
  "compose_form.poll.type": "Loại",
  "compose_form.publish": "Đăng",
  "compose_form.reply": "Trả lời",
  "compose_form.save_changes": "Cập nhật",
  "compose_form.spoiler.marked": "Hủy nội dung ẩn",
  "compose_form.spoiler.unmarked": "Tạo nội dung ẩn",
  "compose_form.spoiler_placeholder": "Nội dung ẩn (tùy chọn)",
  "confirmation_modal.cancel": "Hủy bỏ",
  "confirmations.block.confirm": "Chặn",
  "confirmations.delete.confirm": "Vẫn xóa",
  "confirmations.delete.message": "Bạn có chắc muốn xóa tút này?",
  "confirmations.delete.title": "Xóa tút",
  "confirmations.delete_collection.confirm": "Xóa",
  "confirmations.delete_collection.message": "Hành động này không thể hoàn tác.",
  "confirmations.delete_collection.title": "Xóa \"{name}\"?",
  "confirmations.delete_list.confirm": "Vẫn xóa",
  "confirmations.delete_list.message": "Bạn có chắc muốn xóa vĩnh viễn danh sách này?",
  "confirmations.delete_list.title": "Xóa danh sách",
  "confirmations.discard_draft.confirm": "Bỏ và tiếp tục",
  "confirmations.discard_draft.edit.cancel": "Tiếp tục chỉnh sửa",
  "confirmations.discard_draft.edit.message": "Nếu tiếp tục, bạn sẽ mất mọi thay đổi đã thực hiện đối với tút đang chỉnh sửa.",
  "confirmations.discard_draft.edit.title": "Bỏ những thay đổi với tút?",
  "confirmations.discard_draft.post.cancel": "Tiếp tục soạn",
  "confirmations.discard_draft.post.message": "Nếu tiếp tục, bạn sẽ mất tút đang soạn.",
  "confirmations.discard_draft.post.title": "Bỏ tút đang soạn?",
  "confirmations.discard_edit_media.confirm": "Bỏ qua",
  "confirmations.discard_edit_media.message": "Bạn chưa lưu thay đổi của phần mô tả hoặc bản xem trước của media, vẫn bỏ qua?",
  "confirmations.follow_to_list.confirm": "Theo dõi & thêm vào danh sách",
  "confirmations.follow_to_list.message": "Bạn cần theo dõi {name} trước khi thêm họ vào danh sách.",
  "confirmations.follow_to_list.title": "Theo dõi tài khoản?",
  "confirmations.hide_featured_tab.confirm": "Ẩn tab",
  "confirmations.hide_featured_tab.intro": "Bạn có thể thay đổi bất kỳ lúc nào trong <i>Sửa hồ sơ > Thiết lập Tab hồ sơ</i>.",
  "confirmations.hide_featured_tab.message": "Việc này khiến ẩn tab cho tài khoản trên {serverName} và những máy chủ Mastodon khác. Kiểu hiển thị có thể khác nhau.",
  "confirmations.hide_featured_tab.title": "Ẩn tab \"Nêu bật\"?",
  "confirmations.logout.confirm": "Đăng xuất",
  "confirmations.logout.message": "Bạn có chắc muốn thoát?",
  "confirmations.logout.title": "Đăng xuất",
  "confirmations.missing_alt_text.confirm": "Thêm văn bản thay thế",
  "confirmations.missing_alt_text.message": "Tút của bạn chứa media không có văn bản thay thế. Thêm mô tả giúp nội dung của bạn dễ tiếp cận với nhiều người hơn.",
  "confirmations.missing_alt_text.secondary": "Đăng luôn",
  "confirmations.missing_alt_text.title": "Thêm văn bản thay thế?",
  "confirmations.mute.confirm": "Phớt lờ",
  "confirmations.private_quote_notify.cancel": "Quay lại chỉnh sửa",
  "confirmations.private_quote_notify.confirm": "Đăng tút",
  "confirmations.private_quote_notify.do_not_show_again": "Không hiện thông báo này nữa",
  "confirmations.private_quote_notify.message": "Tài khoản mà bạn trích dẫn và những người được bạn nhắc đến khác sẽ được thông báo và có thể xem tút của bạn, ngay cả khi họ không theo dõi bạn.",
  "confirmations.private_quote_notify.title": "Chia sẻ với tài khoản được nhắc đến và người theo dõi?",
  "confirmations.quiet_post_quote_info.dismiss": "Không nhắc lại nữa",
  "confirmations.quiet_post_quote_info.got_it": "Đã hiểu",
  "confirmations.quiet_post_quote_info.message": "Khi trích dẫn một tút hạn chế, tút của bạn sẽ bị ẩn khỏi dòng thời gian thịnh hành.",
  "confirmations.quiet_post_quote_info.title": "Trích dẫn những tút hạn chế",
  "confirmations.redraft.confirm": "Xóa & viết lại",
  "confirmations.redraft.message": "Điều này sẽ khiến những lượt thích và đăng lại của tút bị mất, cũng như những trả lời sẽ không còn nội dung gốc.",
  "confirmations.redraft.title": "Xóa & viết lại",
  "confirmations.remove_from_followers.confirm": "Xóa người theo dõi",
  "confirmations.remove_from_followers.message": "{name} sẽ không còn theo dõi bạn.Bạn có chắc tiếp tục?",
  "confirmations.remove_from_followers.title": "Xóa người theo dõi?",
  "confirmations.revoke_collection_inclusion.confirm": "Xóa tôi",
  "confirmations.revoke_collection_inclusion.message": "Thao tác này là vĩnh viễn, người tuyển chọn sẽ không thể thêm lại bạn về sau này.",
  "confirmations.revoke_collection_inclusion.title": "Xóa bạn khỏi gói khởi đầu này?",
  "confirmations.revoke_quote.confirm": "Gỡ tút",
  "confirmations.revoke_quote.message": "Hành động này không thể hoàn tác.",
  "confirmations.revoke_quote.title": "Gỡ tút?",
  "confirmations.unblock.confirm": "Bỏ chặn",
  "confirmations.unblock.title": "Bỏ chặn {name}?",
  "confirmations.unfollow.confirm": "Bỏ theo dõi",
  "confirmations.unfollow.title": "Bỏ theo dõi {name}?",
  "confirmations.withdraw_request.confirm": "Thu hồi yêu cầu",
  "confirmations.withdraw_request.title": "Thu hồi yêu cầu theo dõi {name}?",
  "content_warning.hide": "Thu gọn",
  "content_warning.show": "Vẫn xem",
  "content_warning.show_more": "Mở rộng",
  "content_warning.show_short": "Hiện",
  "conversation.delete": "Xóa tin nhắn này",
  "conversation.mark_as_read": "Đánh dấu là đã đọc",
  "conversation.open": "Xem toàn bộ tin nhắn",
  "conversation.with": "Với {names}",
  "copy_icon_button.copied": "Đã sao chép vào bộ nhớ tạm",
  "copy_icon_button.copy_this_text": "Sao chép liên kết vào clipboard",
  "copypaste.copied": "Đã sao chép",
  "copypaste.copy_to_clipboard": "Sao chép vào bộ nhớ tạm",
  "directory.federated": "Ở mạng liên hợp",
  "directory.local": "Ở {domain}",
  "directory.new_arrivals": "Mới tham gia",
  "directory.recently_active": "Hoạt động gần đây",
  "disabled_account_banner.account_settings": "Cài đặt tài khoản",
  "disabled_account_banner.text": "Tài khoản {disabledAccount} của bạn hiện không khả dụng.",
  "dismissable_banner.community_timeline": "Đây là những tút công khai gần đây trong máy chủ {domain}.",
  "dismissable_banner.dismiss": "Bỏ qua",
  "dismissable_banner.public_timeline": "Đây là những tút công khai gần đây trong mạng liên hợp của máy chủ {domain}.",
  "domain_block_modal.block": "Chặn máy chủ",
  "domain_block_modal.block_account_instead": "Chỉ chặn {name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Họ vẫn có thể tương tác với các tút cũ của bạn.",
  "domain_block_modal.they_cant_follow": "Không ai trên máy chủ này có thể theo dõi bạn.",
  "domain_block_modal.they_wont_know": "Họ không biết đã bị bạn chặn.",
  "domain_block_modal.title": "Chặn máy chủ?",
  "domain_block_modal.you_will_lose_num_followers": "Bạn sẽ mất {followersCount, plural, other {{followersCountDisplay} người theo dõi}} và {followingCount, plural, other {{followingCountDisplay} tài khoản mà bạn theo dõi}}.",
  "domain_block_modal.you_will_lose_relationships": "Bạn sẽ mất tất cả người theo dõi và những tài khoản mà bạn theo dõi ở máy chủ này.",
  "domain_block_modal.you_wont_see_posts": "Bạn không còn thấy tút hoặc thông báo từ thành viên máy chủ này.",
  "domain_pill.activitypub_lets_connect": "Nó cho phép bạn kết nối và tương tác với mọi người, không chỉ trên Mastodon mà còn trên các nền tảng khác.",
  "domain_pill.activitypub_like_language": "ActivityPub giống như ngôn ngữ Mastodon giao tiếp với các mạng xã hội khác.",
  "domain_pill.server": "Máy chủ",
  "domain_pill.their_handle": "Địa chỉ Mastodon:",
  "domain_pill.their_server": "Nơi lưu trữ tút của tài khoản này.",
  "domain_pill.their_username": "Độc nhất trên máy chủ này. Những máy chủ khác có thể cũng có tên người dùng giống vậy.",
  "domain_pill.username": "Tên người dùng",
  "domain_pill.whats_in_a_handle": "Địa chỉ Mastodon là gì?",
  "domain_pill.who_they_are": "Vì địa chỉ Mastodon cho biết một người là ai và họ ở đâu, nên bạn có thể tương tác với mọi người trên các nền tảng <button>hỗ trợ ActivityPub</button>.",
  "domain_pill.who_you_are": "Vì địa chỉ Mastodon cho biết bạn là ai và bạn ở đâu, nên mọi người có thể tương tác với bạn từ các nền tảng <button>hỗ trợ ActivityPub</button>.",
  "domain_pill.your_handle": "Địa chỉ Mastodon của bạn:",
  "domain_pill.your_server": "Nơi lưu trữ tút của bạn. Không thích ở đây? Chuyển sang máy chủ khác và giữ nguyên người theo dõi của bạn.",
  "domain_pill.your_username": "Chỉ riêng bạn trên máy chủ này. Những máy chủ khác có thể cũng có tên người dùng giống vậy.",
  "dropdown.empty": "Chọn một lựa chọn",
  "email_subscriptions.email": "Email",
  "email_subscriptions.form.action": "Đăng ký",
  "email_subscriptions.form.bottom": "Nhận tút được gửi đến hộp thư đến mà không cần tài khoản Mastodon. Hủy nhận bất cứ lúc nào. Xem thêm chi tiết tại <a>Chính sách bảo mật</a>.",
  "email_subscriptions.form.title": "Đăng ký nhận cập nhật qua email từ {name}",
  "email_subscriptions.submitted.lead": "Kiểm tra hộp thư đến của bạn để tìm email hoàn tất đăng ký nhận thông báo qua email.",
  "email_subscriptions.submitted.title": "Một bước nữa",
  "email_subscriptions.validation.email.blocked": "Dịch vụ email đã bị chặn",
  "email_subscriptions.validation.email.invalid": "Địa chỉ email không hợp lệ",
  "embed.instructions": "Sao chép đoạn mã dưới đây và chèn vào trang web của bạn.",
  "embed.preview": "Nó sẽ hiển thị như vầy:",
  "emoji_button.activity": "Hoạt động",
  "emoji_button.clear": "Xóa",
  "emoji_button.custom": "Độc đáo",
  "emoji_button.flags": "Cờ",
  "emoji_button.food": "Ăn uống",
  "emoji_button.label": "Chèn emoji",
  "emoji_button.nature": "Thiên nhiên",
  "emoji_button.not_found": "Không tìm thấy emoji",
  "emoji_button.objects": "Đồ vật",
  "emoji_button.people": "Mặt cười",
  "emoji_button.recent": "Thường dùng",
  "emoji_button.search": "Tìm kiếm...",
  "emoji_button.search_results": "Kết quả tìm kiếm",
  "emoji_button.symbols": "Biểu tượng",
  "emoji_button.travel": "Du lịch",
  "empty_column.account_featured.other": "{acct} chưa nêu bật gì.",
  "empty_column.account_featured_self.no_collections_button": "Tạo một gói khởi đầu",
  "empty_column.account_featured_self.no_collections_hide_tab": "Ẩn tab này",
  "empty_column.account_featured_self.pre_collections": "Hãy đón chờ Gói khởi đầu",
  "empty_column.account_featured_self.pre_collections_desc": "Gói khởi đầu (sẽ có trong Mastodon 4.6) cho phép bạn tạo danh sách các tài khoản được tuyển chọn để giới thiệu cho người khác.",
  "empty_column.account_featured_self.showcase_accounts": "Hiện những tài khoản yêu thích của bạn",
  "empty_column.account_featured_self.showcase_accounts_desc": "Gói khởi đầu là những danh sách chứa những tài khoản tuyển chọn để giúp khám phá mọi người trên Fediverse.",
  "empty_column.account_featured_unknown.other": "Tài khoản này chưa nêu bật gì.",
  "empty_column.account_hides_collections": "Tài khoản này đã chọn ẩn thông tin",
  "empty_column.account_suspended": "Tài khoản vô hiệu hóa",
  "empty_column.account_timeline": "Chưa có tút nào!",
  "empty_column.account_unavailable": "Tài khoản bị đình chỉ",
  "empty_column.blocks": "Bạn chưa chặn ai.",
  "empty_column.bookmarked_statuses": "Bạn chưa lưu tút nào. Nếu có, nó sẽ hiển thị ở đây.",
  "empty_column.collections.featured_in": "Bạn chưa được thêm vào gói khởi đầu nào.",
  "empty_column.community": "Máy chủ của bạn chưa có tút nào công khai. Bạn hãy thử viết gì đó đi!",
  "empty_column.direct": "Bạn chưa có tin nhắn riêng nào. Khi bạn gửi hoặc nhận một tin nhắn riêng, nó sẽ xuất hiện ở đây.",
  "empty_column.disabled_feed": "Bảng tin này bị vô hiệu hóa bởi quản trị viên máy chủ của bạn.",
  "empty_column.domain_blocks": "Chưa ẩn bất kỳ máy chủ nào.",
  "empty_column.explore_statuses": "Chưa có gì hot. Kiểm tra lại sau!",
  "empty_column.favourited_statuses": "Bạn chưa thích tút nào. Hãy thử đi, nó sẽ xuất hiện ở đây.",
  "empty_column.favourites": "Chưa có ai thích tút này.",
  "empty_column.follow_requests": "Bạn chưa có yêu cầu theo dõi nào.",
  "empty_column.followed_tags": "Bạn chưa theo dõi hashtag nào. Khi bạn theo dõi, chúng sẽ hiện lên ở đây.",
  "empty_column.hashtag": "Chưa có tút nào dùng hashtag này.",
  "empty_column.home": "Trang chủ của bạn đang trống! Hãy theo dõi nhiều tài khoản hơn để lấp đầy.",
  "empty_column.list": "Chưa có tút. Khi những tài khoản trong danh sách này đăng tút mới, chúng sẽ xuất hiện ở đây.",
  "empty_column.mutes": "Bạn chưa phớt lờ ai.",
  "empty_column.notification_requests": "Sạch sẽ! Không còn gì ở đây. Khi bạn nhận được thông báo mới, chúng sẽ xuất hiện ở đây theo cài đặt của bạn.",
  "empty_column.notifications": "Bạn chưa có thông báo nào. Hãy thử theo dõi hoặc nhắn riêng cho ai đó.",
  "empty_column.public": "Trống trơn! Bạn hãy viết gì đó hoặc bắt đầu theo dõi những tài khoản khác",
  "empty_state.no_results": "Không có kết quả",
  "error.no_hashtag_feed_access": "Tham gia hoặc đăng nhập để xem và theo dõi hashtag này.",
  "error.unexpected_crash.explanation": "Trang này có thể không hiển thị chính xác do lỗi lập trình Mastodon hoặc vấn đề tương thích trình duyệt.",
  "error.unexpected_crash.explanation_addons": "Trang này không thể hiển thị do xung khắc với add-on của trình duyệt hoặc công cụ tự động dịch ngôn ngữ.",
  "error.unexpected_crash.next_steps": "Hãy thử làm mới trang. Nếu vẫn không được, bạn hãy vào Mastodon bằng một ứng dụng di động hoặc trình duyệt khác.",
  "error.unexpected_crash.next_steps_addons": "Hãy tắt add-on và làm tươi trang. Nếu vẫn không được, bạn nên thử đăng nhập Mastodon trên trình duyệt khác hoặc app khác.",
  "errors.unexpected_crash.copy_stacktrace": "Sao chép stacktrace vào clipboard",
  "errors.unexpected_crash.report_issue": "Báo cáo lỗi",
  "explore.suggested_follows": "Mọi người",
  "explore.title": "Xu hướng",
  "explore.trending_links": "Tin tức",
  "explore.trending_statuses": "Tút",
  "explore.trending_tags": "Hashtag",
  "featured_carousel.current": "<sr>Tút</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, other {Tút đã ghim}}",
  "featured_carousel.slide": "Tút {current, number} trong {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Gần đây bạn đã đăng về {items}. Thêm cái này vào hashtag thường dùng?",
  "featured_tags.suggestions.add": "Thêm",
  "featured_tags.suggestions.added": "Quản lý hashtag bạn thường dùng vào bất kỳ lúc nào tại <link>Sửa hồ sơ > Hashtag thường dùng</link>.",
  "featured_tags.suggestions.dismiss": "Không, cảm ơn",
  "filter_modal.added.context_mismatch_explanation": "Danh mục bộ lọc này không áp dụng cho ngữ cảnh mà bạn đã truy cập tút này. Nếu bạn muốn tút cũng được lọc trong ngữ cảnh này, bạn sẽ phải chỉnh sửa bộ lọc.",
  "filter_modal.added.context_mismatch_title": "Bối cảnh không phù hợp!",
  "filter_modal.added.expired_explanation": "Danh mục bộ lọc này đã hết hạn, bạn sẽ cần thay đổi ngày hết hạn để áp dụng.",
  "filter_modal.added.expired_title": "Bộ lọc đã hết hạn!",
  "filter_modal.added.review_and_configure": "Để xem lại và cấu hình chi tiết bộ lọc này, truy cập {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Thiết lập bộ lọc",
  "filter_modal.added.settings_link": "trang cài đặt",
  "filter_modal.added.short_explanation": "Tút này đã được thêm vào bộ lọc: {title}.",
  "filter_modal.added.title": "Đã thêm bộ lọc!",
  "filter_modal.select_filter.context_mismatch": "không áp dụng cho bối cảnh này",
  "filter_modal.select_filter.expired": "hết hạn",
  "filter_modal.select_filter.prompt_new": "Bộ lọc mới: {name}",
  "filter_modal.select_filter.search": "Tìm kiếm hoặc tạo mới",
  "filter_modal.select_filter.subtitle": "Dùng một bộ lọc hiện có hoặc tạo mới",
  "filter_modal.select_filter.title": "Lọc tút này",
  "filter_modal.title.status": "Lọc một tút",
  "filter_warning.matches_filter": "Khớp bộ lọc “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Từ {count, plural, =0 {không ai} other {# tài khoản}} mà bạn có thể biết",
  "filtered_notifications_banner.title": "Thông báo đã lọc",
  "firehose.all": "Toàn bộ",
  "firehose.local": "Máy chủ này",
  "firehose.remote": "Máy chủ khác",
  "follow_request.authorize": "Chấp nhận",
  "follow_request.reject": "Từ chối",
  "follow_requests.unlocked_explanation": "Mặc dù tài khoản của bạn đang ở chế độ công khai, quản trị viên {domain} tin rằng bạn sẽ muốn xem lại yêu cầu theo dõi từ những tài khoản khác.",
  "follow_suggestions.curated_suggestion": "Gợi ý từ máy chủ",
  "follow_suggestions.dismiss": "Không hiện lại",
  "follow_suggestions.featured_longer": "Tuyển chọn bởi {domain}",
  "follow_suggestions.friends_of_friends_longer": "Nổi tiếng với những tài khoản mà bạn theo dõi",
  "follow_suggestions.hints.featured": "Được đội ngũ {domain} đề xuất.",
  "follow_suggestions.hints.friends_of_friends": "Nổi tiếng với những tài khoản mà bạn theo dõi.",
  "follow_suggestions.hints.most_followed": "Được theo dõi nhiều nhất trên {domain}.",
  "follow_suggestions.hints.most_interactions": "Đang được quan tâm nhiều trên {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Tương tự những tài khoản mà bạn theo dõi gần đây.",
  "follow_suggestions.personalized_suggestion": "Gợi ý cá nhân hóa",
  "follow_suggestions.popular_suggestion": "Nổi tiếng",
  "follow_suggestions.popular_suggestion_longer": "Nổi tiếng trên {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Tương tự những tài khoản mà bạn theo dõi gần đây",
  "follow_suggestions.view_all": "Xem tất cả",
  "follow_suggestions.who_to_follow": "Gợi ý theo dõi",
  "followed_tags": "Những hashtag đã theo dõi",
  "followers.hide_other_followers": "Tài khoản này đã ẩn người theo dõi của họ",
  "followers.title": "Đang theo dõi {name}",
  "following.hide_other_following": "Tài khoản này đã ẩn người mà họ theo dõi",
  "following.title": "Theo dõi bởi {name}",
  "footer.about": "Giới thiệu",
  "footer.about_mastodon": "Về Mastodon",
  "footer.about_server": "Về {domain}",
  "footer.about_this_server": "Giới thiệu",
  "footer.directory": "Danh bạ",
  "footer.get_app": "Ứng dụng",
  "footer.keyboard_shortcuts": "Phím tắt",
  "footer.privacy_policy": "Bảo mật",
  "footer.source_code": "Mã nguồn",
  "footer.status": "Trạng thái",
  "footer.terms_of_service": "Điều khoản dịch vụ",
  "form_error.blank": "Không thể để trống trường.",
  "form_field.optional": "(tùy chọn)",
  "generic.saved": "Đã lưu",
  "getting_started.heading": "Quản lý",
  "hashtag.admin_moderation": "Mở giao diện quản trị #{name}",
  "hashtag.browse": "Tìm tút #{hashtag}",
  "hashtag.browse_from_account": "Tìm tút #{hashtag} của @{name}",
  "hashtag.column_header.tag_mode.all": "và {additional}",
  "hashtag.column_header.tag_mode.any": "hoặc {additional}",
  "hashtag.column_header.tag_mode.none": "mà không {additional}",
  "hashtag.column_settings.select.no_options_message": "Không tìm thấy đề xuất nào",
  "hashtag.column_settings.select.placeholder": "Nhập hashtag…",
  "hashtag.column_settings.tag_mode.all": "Toàn bộ",
  "hashtag.column_settings.tag_mode.any": "Một phần",
  "hashtag.column_settings.tag_mode.none": "Không chọn",
  "hashtag.column_settings.tag_toggle": "Bao gồm thêm hashtag cho cột này",
  "hashtag.counter_by_accounts": "{count, plural, other {{counter} người dùng}}",
  "hashtag.counter_by_uses": "{count, plural, other {{counter} tút}}",
  "hashtag.counter_by_uses_today": "{count, plural, other {{counter} tút}} hôm nay",
  "hashtag.feature": "Nêu bật trên hồ sơ",
  "hashtag.follow": "Theo dõi hashtag",
  "hashtag.mute": "Phớt lờ #{hashtag}",
  "hashtag.unfeature": "Bỏ nêu bật trên hồ sơ",
  "hashtag.unfollow": "Bỏ theo dõi hashtag",
  "hashtags.and_other": "…và {count, plural, other {# nữa}}",
  "hints.profiles.followers_may_be_missing": "Số người theo dõi có thể bị thiếu.",
  "hints.profiles.follows_may_be_missing": "Số lượng tài khoản mà tài khoản này theo dõi có thể bị thiếu.",
  "hints.profiles.posts_may_be_missing": "Số lượng tút của tài khoản này có thể bị thiếu.",
  "hints.profiles.see_more_followers": "Xem thêm người theo dõi ở {domain}",
  "hints.profiles.see_more_follows": "Xem thêm người mà tài khoản này theo dõi ở {domain}",
  "hints.profiles.see_more_posts": "Xem thêm tút ở {domain}",
  "home.column_settings.show_quotes": "Hiện những trích dẫn",
  "home.column_settings.show_reblogs": "Hiện những lượt đăng lại",
  "home.column_settings.show_replies": "Hiện những tút dạng trả lời",
  "home.hide_announcements": "Ẩn thông báo máy chủ",
  "home.pending_critical_update.body": "Vui lòng cập nhật máy chủ Mastodon của bạn càng sớm càng tốt!",
  "home.pending_critical_update.link": "Xem bản cập nhật",
  "home.pending_critical_update.title": "Có bản cập nhật bảo mật quan trọng!",
  "home.show_announcements": "Xem thông báo máy chủ",
  "ignore_notifications_modal.disclaimer": "Mastodon sẽ không thông báo cho tài khoản rằng bạn đã bỏ qua thông báo của họ. Họ sẽ vẫn có thể tương tác với bạn.",
  "ignore_notifications_modal.filter_instead": "Lọc thay thế",
  "ignore_notifications_modal.filter_to_act_users": "Bạn vẫn có thể chấp nhận, từ chối hoặc báo cáo tài khoản khác",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Lọc giúp tránh nhầm lẫn tiềm ẩn",
  "ignore_notifications_modal.filter_to_review_separately": "Bạn có thể xem lại các thông báo đã được lọc riêng",
  "ignore_notifications_modal.ignore": "Bỏ qua thông báo",
  "ignore_notifications_modal.limited_accounts_title": "Bỏ qua thông báo từ các tài khoản bị kiểm duyệt?",
  "ignore_notifications_modal.new_accounts_title": "Bỏ qua thông báo từ các tài khoản mới đăng ký?",
  "ignore_notifications_modal.not_followers_title": "Bỏ qua thông báo từ những tài khoản chưa theo dõi bạn?",
  "ignore_notifications_modal.not_following_title": "Bỏ qua thông báo từ những tài khoản mà bạn không theo dõi?",
  "ignore_notifications_modal.private_mentions_title": "Bỏ qua thông báo từ những lượt nhắn riêng không mong muốn?",
  "info_button.label": "Trợ giúp",
  "info_button.what_is_alt_text": "<h1>Văn bản thay thế là gì?</h1> <p>Văn bản thay thế giúp mô tả hình ảnh cho những người khiếm thị, kết nối mạng chậm hoặc đơn giản là bổ sung ngữ cảnh.</p> <p>Bạn có thể cải thiện khả năng tiếp cận và giải thích kỹ hơn cho mọi người bằng cách viết văn bản thay thế rõ ràng, ngắn gọn và khách quan.</p> <ul> <li>Nắm bắt thành phần quan trọng</li> <li>Tóm tắt văn bản trong hình</li> <li>Dùng cấu trúc câu đơn</li> <li>Tránh giải thích rối rắm</li> <li>Tập trung vào các xu hướng và kết luận chính trong hình ảnh phức tạp (như biểu đồ hoặc bản đồ)</li> </ul>",
  "interaction_modal.action": "Để tương tác với tút của {name}, bạn cần đăng nhập vào tài khoản trên một máy chủ Mastodon bất kỳ.",
  "interaction_modal.action_follow": "Để theo dõi {name}, bạn cần đăng nhập vào tài khoản trên một máy chủ Mastodon bất kỳ.",
  "interaction_modal.go": "Đi",
  "interaction_modal.no_account_yet": "Chưa có tài khoản?",
  "interaction_modal.on_another_server": "Trên máy chủ khác",
  "interaction_modal.on_this_server": "Trên máy chủ này",
  "interaction_modal.title": "Đăng nhập để tiếp tục",
  "interaction_modal.username_prompt": "Ví dụ: {example}",
  "intervals.full.days": "{number, plural, other {# ngày}}",
  "intervals.full.hours": "{number, plural, other {# giờ}}",
  "intervals.full.minutes": "{number, plural, other {# phút}}",
  "keyboard_shortcuts.back": "quay lại",
  "keyboard_shortcuts.blocked": "mở danh sách tài khoản đã chặn",
  "keyboard_shortcuts.boost": "đăng lại tút",
  "keyboard_shortcuts.column": "mở các cột",
  "keyboard_shortcuts.compose": "mở khung soạn tút",
  "keyboard_shortcuts.description": "Mô tả",
  "keyboard_shortcuts.direct": "mở nhắn riêng",
  "keyboard_shortcuts.down": "di chuyển xuống dưới danh sách",
  "keyboard_shortcuts.enter": "mở tút",
  "keyboard_shortcuts.explore": "mở bảng tin xu hướng",
  "keyboard_shortcuts.favourite": "thích tút",
  "keyboard_shortcuts.favourites": "mở lượt thích",
  "keyboard_shortcuts.federated": "mở mạng liên hợp",
  "keyboard_shortcuts.heading": "Danh sách phím tắt",
  "keyboard_shortcuts.home": "mở trang chủ",
  "keyboard_shortcuts.hotkey": "Phím tắt",
  "keyboard_shortcuts.legend": "hiện bảng hướng dẫn này",
  "keyboard_shortcuts.load_more": "mở nút \"Tải thêm\"",
  "keyboard_shortcuts.local": "mở máy chủ của bạn",
  "keyboard_shortcuts.mention": "nhắc đến ai đó",
  "keyboard_shortcuts.muted": "mở danh sách tài khoản đã phớt lờ",
  "keyboard_shortcuts.my_profile": "mở hồ sơ của bạn",
  "keyboard_shortcuts.notifications": "mở thông báo",
  "keyboard_shortcuts.open_media": "mở ảnh hoặc video",
  "keyboard_shortcuts.pinned": "mở những tút đã ghim",
  "keyboard_shortcuts.profile": "mở trang của người đăng tút",
  "keyboard_shortcuts.quote": "trích dẫn tút",
  "keyboard_shortcuts.reply": "trả lời",
  "keyboard_shortcuts.requests": "mở danh sách yêu cầu theo dõi",
  "keyboard_shortcuts.search": "mở tìm kiếm",
  "keyboard_shortcuts.spoilers": "ẩn/hiện nội dung nhạy cảm",
  "keyboard_shortcuts.start": "mở \"Dành cho người mới\"",
  "keyboard_shortcuts.toggle_hidden": "ẩn/hiện nội dung ẩn",
  "keyboard_shortcuts.toggle_sensitivity": "ẩn/hiện ảnh hoặc video",
  "keyboard_shortcuts.toot": "soạn tút mới",
  "keyboard_shortcuts.top": "di chuyển đến đầu danh sách",
  "keyboard_shortcuts.translate": "dịch tút",
  "keyboard_shortcuts.unfocus": "đưa con trỏ ra khỏi ô soạn thảo hoặc ô tìm kiếm",
  "keyboard_shortcuts.up": "di chuyển lên trên danh sách",
  "learn_more_link.got_it": "Đã hiểu",
  "learn_more_link.learn_more": "Tìm hiểu thêm",
  "lightbox.close": "Đóng",
  "lightbox.next": "Tiếp",
  "lightbox.previous": "Trước",
  "lightbox.zoom_in": "Kích cỡ gốc",
  "lightbox.zoom_out": "Vừa màn hình",
  "limited_account_hint.action": "Vẫn cứ xem",
  "limited_account_hint.title": "Tài khoản này đã bị ẩn bởi quản trị viên {domain}.",
  "link_preview.author": "Bởi {name}",
  "link_preview.more_from_author": "Viết bởi {name}",
  "link_preview.shares": "{count, plural, other {{counter} lượt chia sẻ}}",
  "lists.add_member": "Thêm",
  "lists.add_to_list": "Thêm vào danh sách",
  "lists.add_to_lists": "Thêm {name} vào danh sách",
  "lists.create": "Tạo",
  "lists.create_a_list_to_organize": "Tạo một danh sách để sắp xếp Bảng tin",
  "lists.create_list": "Tạo danh sách",
  "lists.delete": "Xóa danh sách",
  "lists.done": "Xong",
  "lists.edit": "Sửa danh sách",
  "lists.exclusive": "Ẩn trên Trang chủ",
  "lists.exclusive_hint": "Ẩn tút của những tài khoản này khỏi Trang chủ để tránh trùng lặp.",
  "lists.find_users_to_add": "Tìm tài khoản để thêm vào",
  "lists.list_members_count": "{count, plural, other {# tài khoản}}",
  "lists.list_name": "Tên danh sách",
  "lists.new_list_name": "Tên danh sách mới",
  "lists.no_lists_yet": "Chưa có danh sách nào.",
  "lists.no_members_yet": "Chưa có tài khoản nào.",
  "lists.no_results_found": "Không tìm thấy kết quả nào.",
  "lists.remove_member": "Bỏ ra",
  "lists.replies_policy.followed": "Tài khoản mà bạn theo dõi",
  "lists.replies_policy.list": "Tài khoản trong danh sách",
  "lists.replies_policy.none": "Không ai",
  "lists.save": "Lưu",
  "lists.search": "Tìm kiếm",
  "lists.show_replies_to": "Bao gồm lượt trả lời từ những tài khoản trong danh sách",
  "load_pending": "{count, plural, one {# tút mới} other {# tút mới}}",
  "loading_indicator.label": "Đang tải…",
  "media_gallery.hide": "Ẩn",
  "moved_to_account_banner.text": "Tài khoản {disabledAccount} của bạn hiện không khả dụng vì bạn đã chuyển sang {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Phớt lờ thông báo",
  "mute_modal.hide_options": "Ẩn tùy chọn",
  "mute_modal.indefinite": "Phớt lờ vĩnh viễn",
  "mute_modal.show_options": "Thêm tùy chọn",
  "mute_modal.they_can_mention_and_follow": "Họ vẫn có thể theo dõi & nhắc đến bạn.",
  "mute_modal.they_wont_know": "Họ không biết đã bị bạn phớt lờ.",
  "mute_modal.title": "Phớt lờ tài khoản?",
  "mute_modal.you_wont_see_mentions": "Bạn không còn thấy tút có nhắc đến họ.",
  "mute_modal.you_wont_see_posts": "Bạn không còn thấy tút của họ.",
  "navigation_bar.about": "Giới thiệu",
  "navigation_bar.account_settings": "Bảo mật",
  "navigation_bar.administration": "Quản trị",
  "navigation_bar.advanced_interface": "Dùng bố cục nhiều cột",
  "navigation_bar.automated_deletion": "Xóa tút cũ tự động",
  "navigation_bar.blocks": "Tài khoản đã chặn",
  "navigation_bar.bookmarks": "Tút đã lưu",
  "navigation_bar.collections": "Gói khởi đầu",
  "navigation_bar.direct": "Nhắn riêng",
  "navigation_bar.domain_blocks": "Máy chủ đã ẩn",
  "navigation_bar.favourites": "Tút đã thích",
  "navigation_bar.filters": "Từ khóa đã lọc",
  "navigation_bar.follow_requests": "Yêu cầu theo dõi",
  "navigation_bar.followed_tags": "Hashtag",
  "navigation_bar.follows_and_followers": "Quan hệ",
  "navigation_bar.import_export": "Nhập và xuất",
  "navigation_bar.lists": "Danh sách",
  "navigation_bar.live_feed_local": "Bảng tin (máy chủ)",
  "navigation_bar.live_feed_public": "Bảng tin (công khai)",
  "navigation_bar.logout": "Đăng xuất",
  "navigation_bar.moderation": "Kiểm duyệt",
  "navigation_bar.more": "Khác",
  "navigation_bar.mutes": "Tài khoản đã phớt lờ",
  "navigation_bar.opened_in_classic_interface": "Tút, tài khoản và các trang cụ thể khác được mở theo mặc định trong giao diện web cổ điển.",
  "navigation_bar.preferences": "Thiết lập",
  "navigation_bar.privacy_and_reach": "Riêng tư và tiếp cận",
  "navigation_bar.search": "Tìm kiếm",
  "navigation_bar.search_trends": "Tìm kiếm / Xu hướng",
  "navigation_panel.collapse_followed_tags": "Thu gọn menu hashtag theo dõi",
  "navigation_panel.collapse_lists": "Thu gọn menu danh sách",
  "navigation_panel.expand_followed_tags": "Mở rộng menu hashtag theo dõi",
  "navigation_panel.expand_lists": "Mở rộng menu danh sách",
  "not_signed_in_indicator.not_signed_in": "Bạn cần đăng nhập để truy cập mục này.",
  "notification.added_to_collection": "{name} đã thêm bạn vào một gói khởi đầu",
  "notification.admin.report": "{name} báo cáo {target}",
  "notification.admin.report_account": "{name} báo cáo {count, plural, other {# tút}} của {target} vì {category}",
  "notification.admin.report_account_other": "{name} báo cáo {count, plural, other {# tút}} của {target}",
  "notification.admin.report_statuses": "{name} báo cáo {target} vì {category}",
  "notification.admin.report_statuses_other": "{name} báo cáo {target}",
  "notification.admin.sign_up": "{name} tham gia máy chủ của bạn",
  "notification.admin.sign_up.name_and_others": "{name} và {count, plural, other {# người}} đã đăng ký",
  "notification.annual_report.message": "#Wrapstodon {year} của bạn có rồi đây! Hãy chia sẻ những điểm nhấn và khoảnh khắc đáng nhớ trên Mastodon của bạn trong năm qua!",
  "notification.annual_report.view": "Xem #Wrapstodon",
  "notification.collection_update": "{name} đã chỉnh sửa một gói khởi đầu có bạn",
  "notification.favourite": "{name} đã thích tút của bạn",
  "notification.favourite.name_and_others_with_link": "{name} và <a>{count, plural, other {# người khác}}</a> đã thích tút của bạn",
  "notification.favourite_pm": "{name} đã thích nhắn riêng từ bạn",
  "notification.favourite_pm.name_and_others_with_link": "{name} và <a>{count, plural, other {# người khác}}</a> đã thích nhắn riêng từ bạn",
  "notification.follow": "{name} đã theo dõi bạn",
  "notification.follow.name_and_others": "{name} và <a>{count, plural, other {# người khác}}</a> theo dõi bạn",
  "notification.follow_request": "{name} yêu cầu theo dõi bạn",
  "notification.follow_request.name_and_others": "{name} và {count, plural, other {# người khác}} đã yêu cầu theo dõi bạn",
  "notification.label.mention": "Lượt nhắc",
  "notification.label.private_mention": "Nhắn riêng",
  "notification.label.private_reply": "Trả lời riêng",
  "notification.label.quote": "{name} đã trích dẫn tút của bạn",
  "notification.label.reply": "Trả lời",
  "notification.mention": "Nhắc đến bạn",
  "notification.mentioned_you": "{name} nhắc đến bạn",
  "notification.moderation-warning.learn_more": "Tìm hiểu",
  "notification.moderation_warning": "Bạn vừa nhận một cảnh báo kiểm duyệt",
  "notification.moderation_warning.action_delete_statuses": "Một vài tút của bạn bị gỡ.",
  "notification.moderation_warning.action_disable": "Tài khoản của bạn đã bị vô hiệu hóa.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Vài tút bạn bị đánh dấu nhạy cảm.",
  "notification.moderation_warning.action_none": "Bạn đã nhận một cảnh báo kiểm duyệt.",
  "notification.moderation_warning.action_sensitive": "Tút của bạn sẽ bị đánh dấu nhạy cảm kể từ bây giờ.",
  "notification.moderation_warning.action_silence": "Tài khoản của bạn đã bị hạn chế.",
  "notification.moderation_warning.action_suspend": "Tài khoản của bạn đã bị vô hiệu hóa.",
  "notification.own_poll": "Vốt của bạn đã kết thúc",
  "notification.poll": "Vốt mà bạn tham gia đã kết thúc",
  "notification.quoted_update": "{name} đã chỉnh sửa tút mà bạn trích dẫn",
  "notification.reblog": "{name} đăng lại tút của bạn",
  "notification.reblog.name_and_others_with_link": "{name} và <a>{count, plural, other {# người khác}}</a> đã đăng lại tút của bạn",
  "notification.relationships_severance_event": "Mất kết nối với {name}",
  "notification.relationships_severance_event.account_suspension": "Quản trị viên {from} đã vô hiệu hóa {target}, điều này có nghĩa là bạn không còn có thể nhận được cập nhật từ họ hoặc tương tác với họ nữa.",
  "notification.relationships_severance_event.domain_block": "Quản trị viên {from} đã chặn {target}, bao gồm {followersCount} người theo dõi bạn và {followingCount, plural, other {# người}} mà bạn theo dõi.",
  "notification.relationships_severance_event.learn_more": "Tìm hiểu thêm",
  "notification.relationships_severance_event.user_domain_block": "Bạn đã chặn {target}, xóa {followersCount} người theo dõi bạn và {followingCount, plural, other {# người}} theo dõi bạn.",
  "notification.status": "{name} đăng tút mới",
  "notification.update": "{name} cập nhật tút",
  "notification_requests.accept": "Chấp nhận",
  "notification_requests.accept_multiple": "{count, plural, other {Duyệt # yêu cầu…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, other {Yêu cầu cần duyệt}}",
  "notification_requests.confirm_accept_multiple.message": "Bạn sẽ duyệt {count, plural, other {# yêu cầu thông báo}}. Vẫn tiếp tục?",
  "notification_requests.confirm_accept_multiple.title": "Duyệt yêu cầu thông báo?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, other {Bỏ qua yêu cầu}}",
  "notification_requests.confirm_dismiss_multiple.message": "Bạn sẽ bỏ qua {count, plural, other {# yêu cầu thông báo}}. Bạn sẽ không thể truy cập dễ dàng {count, plural, other {chúng}} nữa. Vẫn tiếp tục?",
  "notification_requests.confirm_dismiss_multiple.title": "Bỏ qua yêu cầu thông báo?",
  "notification_requests.dismiss": "Bỏ qua",
  "notification_requests.dismiss_multiple": "{count, plural, other {Bỏ qua # yêu cầu…}}",
  "notification_requests.edit_selection": "Sửa",
  "notification_requests.exit_selection": "Xong",
  "notification_requests.explainer_for_limited_account": "Thông báo từ tài khoản này đã được lọc vì tài khoản đã bị hạn chế bởi kiểm duyệt viên.",
  "notification_requests.explainer_for_limited_remote_account": "Thông báo từ tài khoản này đã được lọc vì tài khoản hoặc máy chủ của tài khoản đã bị hạn chế bởi kiểm duyệt viên.",
  "notification_requests.maximize": "Tối đa",
  "notification_requests.minimize_banner": "Thu nhỏ mục thông báo đã lọc",
  "notification_requests.notifications_from": "Thông báo từ {name}",
  "notification_requests.title": "Những thông báo đã lọc",
  "notification_requests.view": "Xem thông báo",
  "notifications.clear": "Xóa hết thông báo",
  "notifications.clear_confirmation": "Bạn có chắc muốn xóa vĩnh viễn tất cả thông báo của mình?",
  "notifications.clear_title": "Xóa tất cả thông báo",
  "notifications.column_settings.admin.report": "Báo cáo mới:",
  "notifications.column_settings.admin.sign_up": "Người mới tham gia:",
  "notifications.column_settings.alert": "Báo trên máy tính",
  "notifications.column_settings.favourite": "Lượt thích:",
  "notifications.column_settings.filter_bar.advanced": "Xếp theo từng loại thông báo",
  "notifications.column_settings.filter_bar.category": "Phân loại thông báo",
  "notifications.column_settings.follow": "Người theo dõi:",
  "notifications.column_settings.follow_request": "Yêu cầu theo dõi:",
  "notifications.column_settings.group": "Gộp lại",
  "notifications.column_settings.mention": "Lượt nhắc đến:",
  "notifications.column_settings.poll": "Kết quả vốt:",
  "notifications.column_settings.push": "Thông báo đẩy",
  "notifications.column_settings.quote": "Trích dẫn:",
  "notifications.column_settings.reblog": "Lượt đăng lại:",
  "notifications.column_settings.show": "Báo trên thanh bên",
  "notifications.column_settings.sound": "Kèm âm báo",
  "notifications.column_settings.status": "Tút mới:",
  "notifications.column_settings.unread_notifications.category": "Thông báo chưa đọc",
  "notifications.column_settings.unread_notifications.highlight": "Làm nổi bật thông báo chưa đọc",
  "notifications.column_settings.update": "Sửa tút:",
  "notifications.filter.all": "Tất cả",
  "notifications.filter.boosts": "Đăng lại",
  "notifications.filter.favourites": "Lượt thích",
  "notifications.filter.follows": "Người theo dõi mới",
  "notifications.filter.mentions": "Lượt nhắc đến",
  "notifications.filter.polls": "Kết quả vốt",
  "notifications.filter.statuses": "Cập nhật từ những người bạn theo dõi",
  "notifications.grant_permission": "Cho phép.",
  "notifications.group": "{count} thông báo",
  "notifications.mark_as_read": "Đánh dấu tất cả thông báo là đã đọc",
  "notifications.permission_denied": "Trình duyệt không cho phép hiển thị thông báo trên màn hình.",
  "notifications.permission_denied_alert": "Không thể bật thông báo trên màn hình bởi vì trình duyệt đã từ chối cho phép",
  "notifications.permission_required": "Không thể hiện thông báo trên màn hình bởi vì chưa cho phép.",
  "notifications.policy.accept": "Cho phép",
  "notifications.policy.accept_hint": "Hiện trong thông báo",
  "notifications.policy.drop": "Bỏ qua",
  "notifications.policy.drop_hint": "Bỏ qua vĩnh viễn",
  "notifications.policy.filter": "Lọc",
  "notifications.policy.filter_hint": "Cho vào mục thông báo đã lọc",
  "notifications.policy.filter_limited_accounts_hint": "Chỉ dành cho kiểm duyệt viên",
  "notifications.policy.filter_limited_accounts_title": "Kiểm duyệt tài khoản",
  "notifications.policy.filter_new_accounts.hint": "Dưới {days, plural, other {# ngày}}",
  "notifications.policy.filter_new_accounts_title": "Tài khoản mới tạo gần đây",
  "notifications.policy.filter_not_followers_hint": "Kể cả tài khoản theo dõi bạn dưới {days, plural, other {# ngày}}",
  "notifications.policy.filter_not_followers_title": "Tài khoản không theo dõi bạn",
  "notifications.policy.filter_not_following_hint": "Cho đến khi bạn duyệt họ",
  "notifications.policy.filter_not_following_title": "Tài khoản mà bạn không theo dõi",
  "notifications.policy.filter_private_mentions_hint": "Trừ khi bạn nhắn họ trước hoặc bạn có theo dõi họ",
  "notifications.policy.filter_private_mentions_title": "Nhắn riêng không mong muốn",
  "notifications.policy.title": "Quản lý thông báo từ…",
  "notifications_permission_banner.enable": "Cho phép thông báo trên màn hình",
  "notifications_permission_banner.how_to_control": "Hãy bật thông báo trên màn hình để không bỏ lỡ những thông báo từ Mastodon. Sau khi bật, bạn có thể lựa chọn từng loại thông báo khác nhau bằng nút {icon} bên dưới.",
  "notifications_permission_banner.title": "Không bỏ lỡ điều thú vị nào",
  "onboarding.follows.back": "Quay lại",
  "onboarding.follows.empty": "Không có kết quả có thể được hiển thị lúc này. Bạn có thể thử sử dụng tính năng tìm kiếm hoặc duyệt qua trang khám phá để tìm những người theo dõi hoặc thử lại sau.",
  "onboarding.follows.next": "Tiếp theo: Thiết lập tài khoản",
  "onboarding.follows.search": "Tìm kiếm",
  "onboarding.follows.title": "Tìm người để theo dõi",
  "onboarding.profile.discoverable": "Bật khám phá cho hồ sơ của tôi",
  "onboarding.profile.discoverable_hint": "Khi bạn bật khám phá trên Mastodon, các tút của bạn có thể xuất hiện trong kết quả tìm kiếm và xu hướng, đồng thời hồ sơ của bạn sẽ được đề xuất cho những người có cùng sở thích với bạn.",
  "onboarding.profile.display_name": "Tên gọi",
  "onboarding.profile.display_name_hint": "Tên thật hay biệt danh đều được…",
  "onboarding.profile.finish": "Hoàn thành",
  "onboarding.profile.note": "Giới thiệu",
  "onboarding.profile.note_hint": "Bạn có thể @aiđó hoặc #hashtags…",
  "onboarding.profile.title": "Thiết lập hồ sơ",
  "onboarding.profile.upload_avatar": "Tải lên ảnh đại diện",
  "onboarding.profile.upload_header": "Tải lên ảnh bìa",
  "password_confirmation.exceeds_maxlength": "Mật khẩu vượt quá độ dài mật khẩu tối đa",
  "password_confirmation.mismatching": "Mật khẩu không trùng khớp",
  "picture_in_picture.restore": "Hiển thị bình thường",
  "poll.closed": "Đóng",
  "poll.refresh": "Làm mới",
  "poll.reveal": "Xem kết quả",
  "poll.total_people": "{count, plural, other {# người tham gia}}",
  "poll.total_votes": "{count, plural, other {# lượt vốt}}",
  "poll.vote": "Vốt",
  "poll.voted": "Bạn đã vốt rồi",
  "poll.votes": "{votes, plural, other {# lượt vốt}}",
  "poll_button.add_poll": "Tạo vốt",
  "poll_button.remove_poll": "Xóa vốt",
  "privacy.change": "Chọn kiểu tút",
  "privacy.direct.long": "Những người được nhắc trong tút",
  "privacy.direct.short": "Nhắn riêng",
  "privacy.private.long": "Chỉ người theo dõi",
  "privacy.private.short": "Người theo dõi",
  "privacy.public.long": "Bất kỳ ai",
  "privacy.public.short": "Công khai",
  "privacy.quote.anyone": "{visibility}, cho phép trích dẫn",
  "privacy.quote.disabled": "{visibility}, tắt trích dẫn",
  "privacy.quote.limited": "{visibility}, hạn chế trích dẫn",
  "privacy.unlisted.additional": "Công khai, nhưng tút sẽ không hiện trong bảng tin, hashtag, khám phá hoặc tìm kiếm Mastodon, kể cả trong cài đặt tài khoản bạn chọn cho phép.",
  "privacy.unlisted.long": "Ẩn khỏi kết quả tìm kiếm, xu hướng và bảng tin công khai",
  "privacy.unlisted.short": "Hạn chế",
  "privacy_policy.last_updated": "Cập nhật lần cuối {date}",
  "privacy_policy.title": "Chính sách bảo mật",
  "quote_error.edit": "Không thể thêm trích dẫn khi sửa tút.",
  "quote_error.poll": "Không thể trích dẫn vốt.",
  "quote_error.private_mentions": "Không thể trích dẫn với lượt nhắc trực tiếp.",
  "quote_error.quote": "Chỉ được trích dẫn một lần.",
  "quote_error.unauthorized": "Bạn không được cấp quyền trích dẫn tút này.",
  "quote_error.upload": "Không thể trích dẫn với media đính kèm.",
  "recommended": "Đề xuất",
  "refresh": "Làm mới",
  "regeneration_indicator.please_stand_by": "Chờ một tý.",
  "regeneration_indicator.preparing_your_home_feed": "Đang chuẩn bị bảng tin…",
  "relative_time.days": "{number} ngày",
  "relative_time.full.days": "{number, plural, other {# ngày}}",
  "relative_time.full.hours": "{number, plural, other {# giờ}}",
  "relative_time.full.just_now": "vừa xong",
  "relative_time.full.minutes": "{number, plural, other {# phút}}",
  "relative_time.full.seconds": "{number, plural, other {#s}}",
  "relative_time.hours": "{number} giờ",
  "relative_time.just_now": "vừa xong",
  "relative_time.minutes": "{number} phút",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hôm nay",
  "remove_quote_hint.button_label": "Đã hiểu",
  "remove_quote_hint.message": "Bạn cũng có thể làm trong menu tùy chọn {icon}",
  "remove_quote_hint.title": "Gỡ tút mà bạn đã trích dẫn?",
  "reply_indicator.attachments": "{count, plural, other {# đính kèm}}",
  "reply_indicator.cancel": "Hủy bỏ",
  "reply_indicator.poll": "Vốt",
  "report.block": "Chặn",
  "report.block_explanation": "Bạn sẽ không còn thấy tút của người này. Họ sẽ không thể thấy tút của bạn hoặc theo dõi bạn. Họ biết là bạn đã chặn họ.",
  "report.categories.legal": "Phạm pháp",
  "report.categories.other": "Khác",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Vi phạm nội quy máy chủ",
  "report.category.subtitle": "Chọn lý do phù hợp nhất:",
  "report.category.title": "{type} này có vấn đề gì?",
  "report.category.title_account": "Người",
  "report.category.title_status": "Tút",
  "report.close": "Xong",
  "report.collection_comment": "Vì sao bạn muốn báo cáo gói khởi đầu này?",
  "report.comment.title": "Có điều gì mà chúng tôi cần biết không?",
  "report.forward": "Chuyển đến {target}",
  "report.forward_hint": "Người này thuộc máy chủ khác. Gửi một báo cáo ẩn danh tới máy chủ đó?",
  "report.mute": "Phớt lờ",
  "report.mute_explanation": "Bạn sẽ không còn thấy tút của họ. Họ vẫn có thể thấy tút của bạn hoặc theo dõi bạn. Họ không biết là bạn đã phớt lờ họ.",
  "report.next": "Tiếp theo",
  "report.placeholder": "Thêm lưu ý",
  "report.reasons.dislike": "Tôi không thích",
  "report.reasons.dislike_description": "Đây không phải thứ mà bạn muốn thấy",
  "report.reasons.legal": "Vi phạm pháp luật",
  "report.reasons.legal_description": "Vi phạm pháp luật ở nơi đặt máy chủ hoặc nước bạn",
  "report.reasons.other": "Lý do khác",
  "report.reasons.other_description": "Vấn đề không thuộc những mục trên",
  "report.reasons.spam": "Đây là spam",
  "report.reasons.spam_description": "Liên kết độc hại, giả tương tác hoặc trả lời lặp đi lặp lại",
  "report.reasons.violation": "Vi phạm nội quy máy chủ",
  "report.reasons.violation_description": "Bạn nhận thấy nó vi phạm nội quy máy chủ",
  "report.rules.subtitle": "Chọn tất cả những gì phù hợp",
  "report.rules.title": "Vi phạm nội quy nào?",
  "report.statuses.subtitle": "Chọn tất cả những gì phù hợp",
  "report.statuses.title": "Bạn muốn báo cáo tút nào?",
  "report.submission_error": "Không thể gửi báo cáo",
  "report.submission_error_details": "Kiểm tra kết nối mạng và thử lại sau.",
  "report.submit": "Gửi đi",
  "report.target": "Báo cáo {target}",
  "report.thanks.take_action": "Đây là cách kiểm soát những thứ mà bạn thấy:",
  "report.thanks.take_action_actionable": "Trong lúc chờ chúng tôi xem xét, bạn có thể áp dụng hành động với @{name}:",
  "report.thanks.title": "Không muốn xem thứ này?",
  "report.thanks.title_actionable": "Cảm ơn đã báo cáo, chúng tôi sẽ xem xét kỹ.",
  "report.unfollow": "Bỏ theo dõi @{name}",
  "report.unfollow_explanation": "Bạn đang theo dõi người này. Để không thấy tút của họ trên trang chủ nữa, hãy bỏ theo dõi.",
  "report_notification.attached_statuses": "{count, plural, other {{count} tút}} đính kèm",
  "report_notification.categories.legal": "Pháp lý",
  "report_notification.categories.legal_sentence": "nội dung bất hợp pháp",
  "report_notification.categories.other": "Khác",
  "report_notification.categories.other_sentence": "khác",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Vi phạm nội quy",
  "report_notification.categories.violation_sentence": "vi phạm nội quy",
  "report_notification.open": "Mở báo cáo",
  "search.clear": "Xóa tìm kiếm",
  "search.no_recent_searches": "Gần đây chưa tìm gì",
  "search.placeholder": "Tìm kiếm",
  "search.quick_action.account_search": "Người tên {x}",
  "search.quick_action.go_to_account": "Xem trang {x}",
  "search.quick_action.go_to_hashtag": "Xem hashtag {x}",
  "search.quick_action.open_url": "Mở liên kết trong Mastodon",
  "search.quick_action.status_search": "Tút nhắc đến {x}",
  "search.search_or_paste": "Tìm kiếm hoặc dán URL",
  "search_popout.full_text_search_disabled_message": "Không khả dụng trên {domain}.",
  "search_popout.full_text_search_logged_out_message": "Cần đăng nhập trước.",
  "search_popout.language_code": "mã ngôn ngữ ISO",
  "search_popout.options": "Tìm nâng cao",
  "search_popout.quick_actions": "Thao tác nhanh",
  "search_popout.recent": "Đã tìm gần đây",
  "search_popout.specific_date": "ngày cụ thể",
  "search_popout.user": "địa chỉ Mastodon",
  "search_results.accounts": "Mọi người",
  "search_results.all": "Toàn bộ",
  "search_results.hashtags": "Hashtag",
  "search_results.no_results": "Không có kết quả.",
  "search_results.no_search_yet": "Thử tìm tút, người dùng hoặc hashtag.",
  "search_results.see_all": "Xem tất cả",
  "search_results.statuses": "Tút",
  "search_results.title": "Tìm kiếm \"{q}\"",
  "server_banner.about_active_users": "Những người ở máy chủ này trong 30 ngày qua (MAU)",
  "server_banner.active_users": "người hoạt động",
  "server_banner.administered_by": "Vận hành:",
  "server_banner.is_one_of_many": "{domain} là một trong nhiều máy chủ Mastodon độc lập mà bạn có thể sử dụng để tham gia vào Fediverse.",
  "server_banner.more_about_this_server": "Về máy chủ này",
  "server_banner.server_stats": "Thống kê:",
  "sign_in_banner.create_account": "Đăng ký",
  "sign_in_banner.follow_anyone": "Theo dõi bất kỳ ai trên Fediverse và đọc tút theo thứ tự thời gian. Không thuật toán, quảng cáo hoặc clickbait.",
  "sign_in_banner.mastodon_is": "Mastodon là cách tốt nhất để nắm bắt những gì đang xảy ra.",
  "sign_in_banner.sign_in": "Đăng nhập",
  "sign_in_banner.sso_redirect": "Đăng nhập",
  "skip_links.hotkey": "<span>Phím tắt</span> {hotkey}",
  "skip_links.skip_to_content": "Chuyển tới nội dung chính",
  "skip_links.skip_to_navigation": "Chuyển đến điều hướng chính",
  "status.admin_account": "Mở giao diện quản trị @{name}",
  "status.admin_domain": "Mở giao diện quản trị @{domain}",
  "status.admin_status": "Mở tút này trong giao diện quản trị",
  "status.all_disabled": "Đăng lại và trích dẫn bị tắt",
  "status.block": "Chặn @{name}",
  "status.bookmark": "Lưu",
  "status.cancel_reblog_private": "Bỏ đăng lại",
  "status.cannot_quote": "Bạn không thể trích dẫn tút này",
  "status.cannot_reblog": "Không thể đăng lại tút này",
  "status.contains_quote": "Chứa trích dẫn",
  "status.context.loading": "Tải thêm các trả lời",
  "status.context.loading_error": "Không thể tải những trả lời mới",
  "status.context.loading_success": "Đã tải những lượt trả lời mới",
  "status.context.more_replies_found": "Có trả lời mới",
  "status.context.retry": "Thử lại",
  "status.context.show": "Hiện",
  "status.continued_thread": "Tiếp tục chủ đề",
  "status.copy": "Sao chép liên kết gốc",
  "status.delete": "Xóa",
  "status.delete.success": "Tút đã bị xoá",
  "status.detailed_status": "Xem chi tiết thêm",
  "status.direct": "Nhắn riêng @{name}",
  "status.direct_indicator": "Nhắn riêng",
  "status.edit": "Sửa",
  "status.edited": "Sửa lần cuối {date}",
  "status.edited_x_times": "Đã sửa {count, plural, other {{count} lần}}",
  "status.embed": "Nhúng",
  "status.favourite": "Thích",
  "status.favourites_count": "{count, plural, other {{counter} thích}}",
  "status.filter": "Lọc tút này",
  "status.history.created": "{name} đăng {date}",
  "status.history.edited": "{name} đã sửa {date}",
  "status.load_more": "Tải thêm",
  "status.media.open": "Nhấn để mở",
  "status.media.show": "Nhấn để xem",
  "status.media_hidden": "Đã ẩn",
  "status.mention": "Nhắc đến @{name}",
  "status.more": "Xem thêm",
  "status.mute": "Phớt lờ @{name}",
  "status.mute_conversation": "Phớt lờ thông báo",
  "status.open": "Mở tút",
  "status.pin": "Ghim lên hồ sơ",
  "status.quote": "Trích dẫn",
  "status.quote.cancel": "Bỏ trích dẫn",
  "status.quote_error.blocked_account_hint.title": "Tút này bị ẩn vì bạn đã chặn @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Tút này bị ẩn vì bạn đã chặn {domain}.",
  "status.quote_error.filtered": "Bị ẩn vì một bộ lọc của bạn",
  "status.quote_error.limited_account_hint.action": "Vẫn xem",
  "status.quote_error.limited_account_hint.title": "Người này đã bị ẩn bởi quản trị viên {domain}.",
  "status.quote_error.muted_account_hint.title": "Tút này bị ẩn vì bạn đã phớt lờ @{name}.",
  "status.quote_error.not_available": "Tút không khả dụng",
  "status.quote_error.pending_approval": "Tút đang chờ duyệt",
  "status.quote_error.pending_approval_popout.body": "Trên Mastodon, bạn có thể kiểm soát việc ai đó có thể trích dẫn tút của bạn hay không. Tút này đang chờ phê duyệt từ tác giả gốc.",
  "status.quote_error.revoked": "Tút gốc đã bị tác giả gỡ",
  "status.quote_followers_only": "Chỉ người theo dõi tôi có thể trích dẫn tút này",
  "status.quote_manual_review": "Người đăng sẽ duyệt thủ công",
  "status.quote_noun": "Trích dẫn",
  "status.quote_policy_change": "Thay đổi người có thể trích dẫn",
  "status.quote_post_author": "Trích dẫn từ tút của @{name}",
  "status.quote_private": "Không thể trích dẫn nhắn riêng",
  "status.quotes.empty": "Tút này chưa có ai trích dẫn. Nếu có, nó sẽ hiển thị ở đây.",
  "status.quotes.local_other_disclaimer": "Những trích dẫn bị tác giả từ chối sẽ không được hiển thị.",
  "status.quotes.remote_other_disclaimer": "Chỉ những trích dẫn từ {domain} mới được hiển thị ở đây. Những trích dẫn bị tác giả từ chối sẽ không được hiển thị.",
  "status.quotes_count": "{count, plural, other {{counter} trích dẫn}}",
  "status.read_more": "Đọc tiếp",
  "status.reblog": "Đăng lại",
  "status.reblog_or_quote": "Đăng lại hoặc trích dẫn",
  "status.reblog_private": "Chia sẻ lại với người theo dõi của bạn",
  "status.reblogged_by": "{name} đăng lại",
  "status.reblogs.empty": "Tút này chưa có ai đăng lại. Nếu có, nó sẽ hiển thị ở đây.",
  "status.reblogs_count": "{count, plural, other {{counter} đăng lại}}",
  "status.redraft": "Xóa và viết lại",
  "status.remove_bookmark": "Bỏ lưu",
  "status.remove_favourite": "Bỏ thích",
  "status.remove_quote": "Gỡ",
  "status.replied_in_thread": "Trả lời thảo luận",
  "status.replied_to": "Trả lời {name}",
  "status.reply": "Trả lời",
  "status.replyAll": "Trả lời",
  "status.report": "Báo cáo @{name}",
  "status.request_quote": "Yêu cầu trích dẫn",
  "status.revoke_quote": "Gỡ tút của tôi khỏi trích dẫn của @{name}",
  "status.sensitive_warning": "Nhạy cảm",
  "status.share": "Chia sẻ",
  "status.show_less_all": "Thu gọn",
  "status.show_more_all": "Hiện đầy đủ",
  "status.show_original": "Bản gốc",
  "status.title.with_attachments": "{user} đã đăng {attachmentCount, plural, other {{attachmentCount} đính kèm}}",
  "status.translate": "Dịch tút",
  "status.translated_from_with": "Dịch từ {lang} bằng {provider}",
  "status.uncached_media_warning": "Không bản xem trước",
  "status.unmute_conversation": "Bỏ phớt lờ thông báo",
  "status.unpin": "Bỏ ghim trên hồ sơ",
  "subscribed_languages.lead": "Chỉ các tút đăng bằng các ngôn ngữ đã chọn mới được xuất hiện trên bảng tin của bạn. Không chọn gì cả để đọc tút đăng bằng mọi ngôn ngữ.",
  "subscribed_languages.save": "Lưu thay đổi",
  "subscribed_languages.target": "Đổi ngôn ngữ mong muốn cho {target}",
  "tabs_bar.home": "Trang chủ",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Thông báo",
  "tabs_bar.publish": "Soạn tút",
  "tabs_bar.search": "Tìm kiếm",
  "tag.remove": "Gỡ bỏ",
  "terms_of_service.effective_as_of": "Có hiệu lực vào {date}",
  "terms_of_service.title": "Điều khoản Dịch vụ",
  "terms_of_service.upcoming_changes_on": "Sắp thay đổi vào {date}",
  "time_remaining.days": "{number, plural, other {# ngày}}",
  "time_remaining.hours": "{number, plural, other {# giờ}}",
  "time_remaining.minutes": "{number, plural, other {# phút}}",
  "time_remaining.moments": "Còn lại",
  "time_remaining.seconds": "{number, plural, other {# giây}}",
  "trends.counter_by_accounts": "{count, plural, other {{count} lượt}} dùng trong {days, plural, other {{days} ngày}} qua",
  "trends.trending_now": "Xu hướng",
  "ui.beforeunload": "Bản nháp của bạn sẽ bị mất nếu bạn thoát khỏi Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Kéo và thả để tải lên",
  "upload_button.label": "Thêm media (JPEG, PNG, GIF, WebM, MP4, MOV)",
  "upload_error.limit": "Tệp tải lên vượt quá giới hạn cho phép.",
  "upload_error.poll": "Không cho phép đính kèm tệp.",
  "upload_error.quote": "Không cho phép đính kèm tệp với trích dẫn.",
  "upload_form.drag_and_drop.instructions": "Để chọn tệp đính kèm, hãy nhấn phím cách hoặc phím Enter. Trong khi kéo, sử dụng các phím mũi tên để di chuyển tệp đính kèm theo bất kỳ hướng nào. Nhấn phím cách hoặc phím Enter một lần nữa để thả tệp đính kèm vào vị trí mới hoặc nhấn phím thoát để hủy.",
  "upload_form.drag_and_drop.on_drag_cancel": "Kéo thả đã bị hủy bỏ. Tệp đính kèm {item} bị bỏ qua.",
  "upload_form.drag_and_drop.on_drag_end": "Tệp đính kèm {item} bị bỏ qua.",
  "upload_form.drag_and_drop.on_drag_over": "Tệp đính kèm {item} bị di chuyển.",
  "upload_form.drag_and_drop.on_drag_start": "Đã chọn tệp đính kèm {item}.",
  "upload_form.edit": "Biên tập",
  "upload_progress.label": "Đang tải lên...",
  "upload_progress.processing": "Đang tải lên…",
  "username.taken": "Tên người dùng đã được sử dụng. Hãy thử tên khác",
  "video.close": "Đóng video",
  "video.download": "Lưu về máy",
  "video.exit_fullscreen": "Thoát toàn màn hình",
  "video.expand": "Mở rộng video",
  "video.fullscreen": "Toàn màn hình",
  "video.hide": "Ẩn video",
  "video.mute": "Tắt tiếng",
  "video.pause": "Tạm dừng",
  "video.play": "Phát",
  "video.skip_backward": "Tua lùi",
  "video.skip_forward": "Tua tới",
  "video.unmute": "Bật tiếng",
  "video.volume_down": "Giảm âm lượng",
  "video.volume_up": "Tăng âm lượng",
  "visibility_modal.button_title": "Thay đổi quyền riêng tư",
  "visibility_modal.direct_quote_warning.text": "Nếu bạn lưu cài đặt hiện tại, trích dẫn được nhúng sẽ được chuyển đổi thành liên kết.",
  "visibility_modal.direct_quote_warning.title": "Không thể nhúng trích dẫn vào Nhắn Riêng",
  "visibility_modal.header": "Hiển thị và tương tác",
  "visibility_modal.helper.direct_quoting": "Không thể trích dẫn tút Nhắn riêng trên Mastodon.",
  "visibility_modal.helper.privacy_editing": "Không thể thay đổi chế độ hiển thị sau khi một tút đã đăng.",
  "visibility_modal.helper.privacy_private_self_quote": "Không thể công khai trích dẫn tút của bản thân hoặc tút riêng tư.",
  "visibility_modal.helper.private_quoting": "Không thể trích dẫn tút chỉ dành cho người theo dõi trên Mastodon.",
  "visibility_modal.helper.unlisted_quoting": "Khi ai đó trích dẫn bạn, tút của họ cũng sẽ bị ẩn khỏi bảng tin công khai.",
  "visibility_modal.instructions": "Kiểm soát những ai có thể tương tác với tút này. Bạn cũng có thể đặt sẵn cho tất cả tút trong tương lai bằng cách truy cập <link>Thiết lập > Mặc định cho tút</link>.",
  "visibility_modal.privacy_label": "Hiển thị",
  "visibility_modal.quote_followers": "Chỉ người theo dõi",
  "visibility_modal.quote_label": "Ai có thể trích dẫn",
  "visibility_modal.quote_nobody": "Chỉ tôi",
  "visibility_modal.quote_public": "Bất kỳ ai",
  "visibility_modal.save": "Lưu"
}
